import { HttpParams } from '@angular/common/http';
import { Component, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { ColDef, GridReadyEvent, SelectionChangedEvent, IMultiFilterParams, FilterChangedEvent, GridPreDestroyedEvent, GridOptions, CellPosition, ExcelStyle } from 'ag-grid-community';
import { ConfirmationService } from 'primeng/api';
import { ApiService } from 'src/app/services/api.service';
import { CustomMessageService } from 'src/app/services/custom.message.service';
import { StaticFields } from 'src/app/shared/staticFields';
import { ColorFilter } from 'src/app/shared/colorFilter';
import { SetCustomColorComponent } from 'src/app/shared/setCustomColor';
import { LoadingService } from 'src/app/services/loading.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GeassessmentmodalComponent } from '../geassessmentmodal/geassessmentmodal.component';
import { GridPreference } from 'src/app/models/gridPreference';
import { Crop } from 'src/app/models/crop';
import { Router } from '@angular/router';
import { UserPreferredGeTrait } from 'src/app/models/userPreferredGeTrait';
import { CommonreportmodalComponent } from '../commonreportmodal/commonreportmodal.component';
import { CommonService } from 'src/app/services/common.service';
import { ResetService } from 'src/app/services/reset.service';
import { CheckboxChangeEvent } from 'primeng/checkbox';
import { MultiSelectComponent } from 'src/app/shared/multiSelectComponent';
import { CustomStatusBarComponent } from 'src/app/shared/custom-status-bar';
import { SettingService } from 'src/app/services/setting.service';
import { Settings } from 'src/app/models/settings';
import { SignalRService } from 'src/app/services/signalr.service';
import { Reset } from 'src/app/models/reset';
import { RadioButtonClickEvent } from 'primeng/radiobutton';

@Component({
  selector: 'app-manageprogram',
  templateUrl: './manageprogram.component.html',
  styleUrl: './manageprogram.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class ManageprogramComponent {
  programsToCode: any[] = [];
  yearsToCode: any[] = [];
  //@HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(event: KeyboardEvent) {
  //   if (event.ctrlKey && event.key === 'a') {
  //     if (this.gridApi && this.gridApi.getSelectedRows().length > 0) {
  //       this.gridApi.forEachNodeAfterFilterAndSort((n: any) => n.setSelected(true));
  //     }
  //   }
  // }
  @ViewChild('customStatusBar') customStatusBar!: CustomStatusBarComponent;
  @ViewChild('advGridFilterBar') advGridFilterBar!: CustomStatusBarComponent;
  gridApi: any;
  advGEGridApi: any;
  rowData: any[] = [];
  rowDataCopy: any[] = [];
  advGEsRowData: any[] = [];
  advGEsRowDataCopy: any[] = [];
  showGEsToAdvance: boolean = false;
  genToExpand: any;
  genToExpandAll : any;
  gridColDef: ColDef[] = [];
  advGEGridColDef: ColDef[] = [];
  selectedCodeProgram: any;
  selectedCodeYear : any;
  confirmCodeSearch: boolean = false;
  defColWidth = 100;
  editedData: any = {};
  defToolPanel = {  
    toolPanels: [{
      id: "columns",
      labelDefault: "Columns",
      labelKey: "columns",
      iconKey: "columns",
      toolPanel: "agColumnsToolPanel",
      toolPanelParams: {
        suppressRowGroups: true,
        suppressValues: true,
        suppressPivotMode: true,
      },
    },
    'filters'] 
  };
  gridOptions : GridOptions = {
    undoRedoCellEditing: true,
    undoRedoCellEditingLimit: 20,
    suppressLastEmptyLineOnPaste: true,
    tooltipShowDelay: 100,
    columnDefs: this.gridColDef,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: ColorFilter
          },
          {
            filter: "agSetColumnFilter",
            filterParams: { buttons: ["clear"] }
          },
        ],
        refreshValuesOnOpen: true
      } as IMultiFilterParams,
      resizable: true,
      minWidth: 20,
      width: this.defColWidth,
      cellStyle: (params: any) => {
        const colId = params.column.getColId();
        const cellId = `${colId}_cellColor`;
        let style: any = null;
        // if (StaticFields.precodeScreenData.selNodes && StaticFields.precodeScreenData.selNodes.indexOf(params.data.id) > -1) {
        //   style = null;
        // } else 
        if (params.data && params.data[cellId] && params.data[cellId] !== 'No Fill') {
          if (!this.existingGridColors.includes(params.data[cellId]))
            this.existingGridColors.push(params.data[cellId]);
          style = { backgroundColor: params.data[cellId]};
        } else {
          style = null;
        }
        if (this.editedData[`${params.data.id}:${colId}`])
          style = style ? {"border-right": "2px solid lightgreen", backgroundColor: style.backgroundColor } : {"border-right": "2px solid lightgreen"};
        return style;
      },
      headerClass: (params: any) => {
        if (params.colDef.field === 'selected')
          return 'selectionHeader';
        const headerGrp = this.headerMap[params.colDef.field];
        if (headerGrp) {
          const prgNo = headerGrp.includes(':apex') ? this.selPrgs[headerGrp.replace(':apex', '').toLowerCase()] : this.selPrgs[headerGrp.toLowerCase()];
          if (prgNo)
            return `${prgNo}Header`;
        }
        return headerGrp ? `${headerGrp}Header` : '';
      },
      toolPanelClass: (params: any) => {
        const headerGrp = this.headerMap[params.colDef.field];
        if (headerGrp) {
          const prgNo = headerGrp.includes(':apex') ? this.selPrgs[headerGrp.replace(':apex', '').toLowerCase()] : this.selPrgs[headerGrp.toLowerCase()];
          if (prgNo)
            return `${prgNo}Header`;
        }
        return headerGrp ? `${headerGrp}Header` : '';
      }
    },
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left',  },
        { statusPanel: 'agFilteredRowCountComponent', align : 'left' },
        { statusPanel: 'agSelectedRowCountComponent', align : 'left' },
        {
          statusPanel : SetCustomColorComponent,
          align: 'left',
        },
        { statusPanel: 'agAggregationComponent', align: 'right' }
      ],
    },
    getContextMenuItems: this.getContextMenuItems,
    sideBar: this.defToolPanel,
    onGridPreDestroyed: this.onGridPreDestroyed,
    context: {
      componentParent: this
    },
   
  };
  advGEGridOptions : GridOptions = {
    undoRedoCellEditing: true,
    suppressLastEmptyLineOnPaste: true,
    undoRedoCellEditingLimit: 20,
    tooltipShowDelay: 100,
    columnDefs: this.advGEGridColDef,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      resizable: true,
      minWidth: 20,
      width: this.defColWidth,
      headerClass: (params: any) => {
        const headerGrp = this.childGridHeaderMap[params.colDef.field];
        if (headerGrp) {
          const prgNo = this.selPrgs[headerGrp.toLowerCase()];
          if (prgNo)
            return `${prgNo}Header`;
        }
        return headerGrp ? `${headerGrp}Header` : '';
      }
    },
    statusBar: {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'left' },
        { statusPanel: 'agTotalAndFilteredRowCountComponent', align: 'left',  },
        { statusPanel: 'agFilteredRowCountComponent', align : 'left' },
        { statusPanel: 'agSelectedRowCountComponent', align : 'left' },
        { statusPanel: 'agAggregationComponent' }
      ],
    },
    getContextMenuItems: this.getAdvGEContextMenuItems,
    sideBar: this.defToolPanel,
    context: {
      componentParent: this
    }
  };
  showSearch: boolean = false;
  showSessions: boolean = false;
  selColor: any = '#ffffff';
  selectedCrop: any;
  metaDataList: string[] = [];
  selectedMetaData: any;
  levels: any[] = [{name: 'Program(s)'},{name: 'Region(s)'},{name: 'EZ(s)'}];
  selectedLevel: any;
  inclusions: any[];
  selectedInclusions: any;
  allStageValues: any = [];
  stages: string[] = [];
  selectedStages: any;
  years: string[] = StaticFields.years;
  selectedYears: any[] = [];
  geLineageChecked: boolean = false;
  seedInventoryChecked: boolean = false;
  popRequestChecked: boolean = false;
  experimentsChecked: boolean = false;
  apexVoteChecked : boolean = false;
  regions: any[] = [];
  ezs: any = [];
  programs: any = [];
  selProgram: any;
  userGridPreference : GridPreference = new GridPreference();
  //precodePreference : PreCodePreferences = new PreCodePreferences();
  settingPageLoadData: boolean = false;
  foundCell: any[] = [];
  foundIndex = 0;
  lastFoundCell: any;
  found = false;
  showFindReplace = false;
  findText: string = "";
  replaceText: string = "";
  matchCaseChecked = false;
  matchWordChecked = false;
  existingGridColors: any[] = [];
  showColorSelector: boolean = false;
  showSaveModal: boolean = false;
  showCopyModal: boolean = false;
  expandByAllOptions = ['All'];
  sessionName: string = '';
  sessionDesc: string = '';
  sessionCopyName: string = '';
  sessionType: string = 'SaveNewSession';
  copyType: string = 'copy';
  sharedById: any;
  sessions: any = [];
  sessionsCopy: any = [];
  replaceSession: boolean = false;
  selSession: any;
  ref: DynamicDialogRef;
  // genToFetch: any = {name:"0", val: 0};
  // genList: any = [{name:"All", val: -100},{name:"5", val: 5},{name:"4", val: 4},{name:"3", val: 3},{name:"2", val: 2},{name:"1", val: 1},{name:"0", val: 0},{name:"-1", val: -1},{name:"-2", val: -2},{name:"-3", val: -3},{name:"-4", val: -4},{name:"-5", val: -5}];
  showPStageModal: boolean = false;
  newPStageIds: string[] = [];
  pStageData: any[] = [];
  favProgramsChecked: boolean = false;
  selPrgs: any = {};
  rowDataCopyForFilter: any;
  gridHeight: string;
  tagList: string[] = [];
  wrapHeader: boolean;
  loadingCount: number = 0;
  
  pStageColDef: ColDef[] = [
    { field: 'settingType', headerName: 'Type', cellEditor: 'agSelectCellEditor', editable: this.allowPStageEdit.bind(this),
        cellEditorParams: () => { return { values: ["PStage","Vote"], valueListMaxHeight: 100 } }},
    { field: 'type', headerName: 'Level', cellEditor: 'agSelectCellEditor', editable: this.allowPStageEdit.bind(this),
        cellEditorParams: (params: any) => { return { values: params.data.settingType === "PStage" && !(StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0) ? ["Program(s)","Region(s)","EZ(s)"] : ["Program(s)"], valueListMaxHeight: 100 } }},
    { field: 'name', headerName: 'Name', cellEditor: 'customMultiSelectEditor' , editable: this.allowPStageEdit.bind(this),
      suppressKeyboardEvent: params => {
        const key = params.event.key;
        const gridShouldDoNothing = params.editing && (key === "Enter");
        return gridShouldDoNothing;
      }
    },
    { field: 'year',headerName : 'Year',  cellEditor: 'customMultiSelectEditor', editable: this.allowPStageEdit.bind(this),
      suppressKeyboardEvent: params => {
        const key = params.event.key;
        const gridShouldDoNothing = params.editing && (key === "Enter");
        return gridShouldDoNothing;
      },
      cellEditorParams : (params : any )=> {
        return {values:StaticFields.years, dataSourceType: "years"}
      }
    }
  ];
  defaultPStageColDef: ColDef = {
    sortable: true,
    filter: true,
    filterParams: { buttons: ["clear"] },
    minWidth : 20, 
    resizable: true,
  };
  gridOptionsPStage : GridOptions = {
    context: {
      componentParent: this,
    },
    singleClickEdit: true
  };
  pStageDataCopy: any;
  pStageGridApi: any;
  selectedPStageCrop: any;
  pStageRegions: any;
  pStageEzs: any;
  pStagePrograms: any;
  geAssessmentsList: UserPreferredGeTrait[] = [];
  selectedAssessments: any[] = [];
  selectedPStages: any[] = [];
  pStagesList: any[] = [];
  showADDialog: boolean = false;
  sessionToShare: string;
  searchMemberString: string;
  shareDescription: string;
  adUserData: any = [];
  userGridApi: any;
  userDefaultColDef: ColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: { buttons: ["clear"] },
    resizable: true,
    minWidth: 20
  };
  userColumnDefs: ColDef[] = [
    { field: 'displayName',headerName: 'Display Name', checkboxSelection: true, width: 200 },
    { field: 'onPremisesSamAccountName',headerName: 'User Name', width: 150 },
    { field: 'mail', headerName: 'Email', flex: 2}
  ];
  sessionGridApi: any;
  sessionDefaultColDef: ColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: { buttons: ["clear"] },
    resizable: true,
    width: 120,
    minWidth: 20
  };
  sessionColumnDefs: ColDef[] = [
    { field: 'name', headerName: 'Name', checkboxSelection: true, headerCheckboxSelection: true, tooltipField: "description", editable: true },
    { field: 'sessionDescription', headerName: 'Description', editable: true, tooltipField: "sessionDescription", headerTooltip: "Description" },
    { field: 'geCount', headerName: 'GE Count', headerTooltip: "GE Count" },
    { field: 'updatedOn', headerName: 'Last Viewed', headerTooltip: "Last Viewed" },
    { field: 'createdOn', headerName: 'Create Date', headerTooltip: "Create Date" },
    { field: 'count', headerName: 'Shared Count', headerTooltip: "Shared Users Count" }
  ];
  showBulkEditDialog: boolean = false;
  editPStageChecked: boolean = false;
  editCommentsChecked: boolean = false;
  editMetadataChecked: boolean = false;
  editCusMetadataChecked: boolean = false;
  bulkYear: number;
  bulkYears: number[] = [];
  bulkPStage: string;
  bulkComments: string;
  bulkMetaData: any = [];
  bulkTags: any = [];
  bulkEditPrgs: string[] = [];
  selBulkEditPrg: string;
  appendComments: boolean = true;
  appendMetadata: boolean = true;
  appendTags: boolean = true;
  showPStageGrid: boolean = true;
  showGeTraitGrid: boolean = true;
  cropReset: boolean;
  showAPEXJobs: boolean = false;
  apexGridApi: any;
  showMyAPEXJobs: boolean = true;
  apexData: any[] = [];
  allApexData: any[] = [];
  showHistoryDialog: boolean = false;
  historyData: any[] = [];
  showDefaultHeaders: string = "false";
  cancelBatch: boolean = false;

  apexColDef: ColDef[] = [
    // { field: 'crop', headerName: 'Crop' },
    { field: 'name', headerName: 'Name', width: 350 },
    { field: 'jobType', headerName: 'Owner', width: 240 },
    { field: 'createDate', headerName : 'Created Date', width: 140, valueFormatter: p => {
        const d = p.value == null ? new Date() : new Date(p.value);
        return p.value == null ? '' : `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
      }
    },
    { field: 'description', headerName : 'Description', width: 350 },
    { field: 'isVoting', headerName : 'Is Voting', cellDataType: 'text', valueFormatter: p => p.value ? 'Yes' : 'No', width: 120 },
  ];
  apexStatusBar = {
    statusPanels: [
      { statusPanel: 'agTotalRowCountComponent', align: 'left' },
      { statusPanel: 'agFilteredRowCountComponent', align : 'left' }
    ]
  }

  historyColDef: ColDef[] = [  
    { field: 'name', headerName: 'Name', width: 100 },
    { field: 'year', headerName: 'Year', width: 100 },  
    { field: 'actionTakenOn', headerName: 'Action Taken On', width: 150 },  
    { field: 'actionTakenBy', headerName: 'Action Taken By', width: 240 },  
    { field: 'field', headerName : 'Field', width: 150 },
    { field: 'oldVal', headerName : 'Old Value', width: 240 },
    { field: 'newVal', headerName : 'New Value', width: 240 }
  ];
  
  inclusionsCopy: any;
  addGEModal: boolean = false;
  idList: string[] = [];
  searchBy: string = 'GE ID';
  showUsageModal: boolean = false;
  selUsageYears: Number[] = [];
  selUsagePrograms: string[] = [];
  selUsageStages: string[] = [];
  showNurserySelection: boolean = false;
  assocExpts: any = [];
  selectedExpts: any = [];
  selectedPrg: any;
  headerLegend: any[] = [{type: "GE", color : "#C0E6F5" },
    {type: "SI", color : "#F1A983" },
    {type: "POP", color : "#C1F0C8" },
    {type: "EXPT", color : "#7ff0d7" },
    {type: "APEX", color : "#FFFFCC" },
    {type: "TRAIT", color : "#f7d3a1" }
  ];
  headerMap: any;
  childGridHeaderMap: any;
  overlayVisible: boolean = false;
  public components: {
      [p: string]: any;
    } = {
      customMultiSelectEditor: MultiSelectComponent,
    };
  searchHeight: number;
  sideBarHeight: string;
  selGEsOnly: boolean = true;

  constructor(@Inject(SettingService) private config: Settings,public customMessageService: CustomMessageService, private apiService : ApiService,private commonService: CommonService, private router : Router,
    private confirmationService: ConfirmationService , public loader: LoadingService,public dialogService: DialogService,  private resetService: ResetService,  private signalRService: SignalRService) { 
    this.resetService.resetData$.subscribe((reset : Reset) => {
      if (reset) {
        if (ResetService.Crops == reset.Type){
          this.cropReset = true;
          this.resetSearch();
        }
        if (ResetService.Programs == reset.Type){
          this.getProgramPreference();
        }
        if (ResetService.EvaluationZones == reset.Type){
          this.getEvaluationZonePreference();          
        }
        // if (ResetService.Marker == reset.Type){
        //    this.resetMarkerCountAfterSignalRResponse(reset.Data);
        // }
      }
    });
  }

  get allowReset() : boolean {
    if (StaticFields.precodePreference && this.selectedCrop && this.selectedLevel) {
      return this.selectedCrop.Name !== StaticFields.precodePreference.crop || this.selectedLevel.name !== StaticFields.precodePreference.level || 
      (this.selectedInclusions && this.selectedInclusions.length > 0 && JSON.stringify(this.selectedInclusions.map((i: any) => i.code).sort((a: any,b : any) => a-b)) !== JSON.stringify(StaticFields.precodePreference.include.split(",").sort((a: any,b: any) => a-b))) ||
      (this.selectedStages && this.selectedStages.length > 0 && JSON.stringify(this.selectedStages.sort((a: any,b : any) => a-b)) !== JSON.stringify(StaticFields.precodePreference.stage.split(",").sort((a: any,b: any) => a-b))) ||
      (this.selectedYears && this.selectedYears.length > 0 && JSON.stringify(this.selectedYears.sort((a: any,b : any) => a-b)) !== JSON.stringify(StaticFields.precodePreference.years.split(",").sort((a: any,b: any) => a-b))) ||
      this.geLineageChecked !== StaticFields.precodePreference.geLineage || this.popRequestChecked !== StaticFields.precodePreference.popRequest || this.apexVoteChecked !== StaticFields.precodePreference.apexVote ||
      this.seedInventoryChecked !== StaticFields.precodePreference.seedInventory || this.experimentsChecked !== StaticFields.precodePreference.experiments || this.rowData.length > 0;  
    } else {
      return this.selectedCrop || this.geLineageChecked || this.seedInventoryChecked || this.popRequestChecked || this.experimentsChecked || this.apexVoteChecked ||this.rowData.length > 0;
    }
  }

  get allowLegendReset() : boolean {  
    return JSON.stringify(this.headerLegend) != StaticFields.precodePreference?.headerColorOptions;
  }

  get allowLegendResetForSession(): boolean {
    if(StaticFields?.precodeScreenData)
      return JSON.stringify(this.headerLegend) != JSON.stringify(StaticFields?.precodeScreenData?.headerLegend);
    else
      return true
  }

  get isProd(): boolean {
    return this.config.environment.toUpperCase() === 'PROD';
  }

  get updatedData(): any {
    return this.rowData.filter(g => g.hasChanges);
  }

  get updatedAdvGEData(): any {
    return this.advGEsRowData.filter(g => g.hasChanges);
  }

  get crops(): Crop [] {
    return StaticFields.crops?.filter(ele => ele.isActive);
  }

  get isAllowAppendSession() : boolean {
    if (!this.sessionName)
      return null;
    if (StaticFields.precodeScreenData) {
      //let geAssesmentChanges: boolean = [...StaticFields.precodeScreenData.geAssessmentsList].filter(p => this.geAssessmentsList.map((p1: any) => p1.traitId).includes(p.traitId)).length !== this.geAssessmentsList.length;
      let selGeAssesmentChanges: boolean = [...StaticFields.precodeScreenData.selectedAssessmentsList].filter(p => this.selectedAssessments.map((p1: any) => p1.traitId).includes(p.traitId)).length !== this.selectedAssessments.length;  
      let selectedGeAssesmentChanges: boolean = [...StaticFields.precodeScreenData.selectedAssessmentsList].length !== this.selectedAssessments.length;    
      //let pSgtagesChanges: boolean = [...StaticFields.precodeScreenData.pStagesList].filter(p => this.pStagesList.map((p1: any) => p1.id).includes(p.id)).length !== this.pStagesList.length;
      let selPSgtagesChanges: boolean = [...StaticFields.precodeScreenData.selectedPStages].filter(p => this.selectedPStages.map((p1: any) => p1.id).includes(p.id)).length !== this.selectedPStages.length;
      let selectedPSgtagesChanges: boolean = [...StaticFields.precodeScreenData.selectedPStages].length !== this.selectedPStages.length;
      // return geAssesmentChanges || selGeAssesmentChanges || selectedGeAssesmentChanges || pSgtagesChanges || selPSgtagesChanges || selectedPSgtagesChanges;
       return selGeAssesmentChanges || selectedGeAssesmentChanges || selPSgtagesChanges || selectedPSgtagesChanges;
    } else {
      return false;
    }
  }

  get disableShowSelected(): boolean {
    let disableShowSelected = !(this.gridApi && this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length > 0);
    if (this.rowDataCopyForFilter && this.rowDataCopyForFilter.length > 0)
      return disableShowSelected && this.rowData.length === this.rowDataCopyForFilter;
    return disableShowSelected;
  }

  get hasFilterApplied(): boolean {
    if (this.gridApi && !this.gridApi.isDestroyed() && this.gridApi.getFilterModel())
      return Object.keys(this.gridApi.getFilterModel()).length > 0;
    return false;
  }
  get validPstageData() : number {
    let count = 0;
    this.pStageData.forEach(ele => {
      if(ele.type !== "" && (ele.name.length > 0 && ele.year.length > 0)) {
        count++;
      }
    })
    return count;
  }

  get allowPStageSettingSave() : boolean {
    return JSON.stringify(this.pStageData) === JSON.stringify(this.pStageDataCopy);
  }

  get getUserSelectedRows() : any {
    if (this.userGridApi)
      return this.userGridApi.getSelectedRows();
    return null;
  }

  get sessionNames(): string[] {
    return this.sessions.map((s: any) => s.name);
  }
  get allowUpdateSessions(): boolean {
    let allowUpdate = false;
    this.sessions.forEach((s: any) => {
      if (this.sessionsCopy.findIndex((sc: any) => sc.name === s.name && sc.sessionDescription === s.sessionDescription) === -1)
        allowUpdate = true;
    });
    return allowUpdate;
  }

  get allowUndo(): boolean {
    return this.gridApi && this.gridApi.getCurrentUndoSize() > 0;
  }
  get allowRedo(): boolean {
    return this.gridApi && this.gridApi.getCurrentRedoSize() > 0;
  }

  ngOnInit(): void {
    if (StaticFields.appUserId && StaticFields.crops && StaticFields.crops.length > 0)
      this.initialCalls();
    else {
      const interval = setInterval(() => {
        if (StaticFields.appUserId && StaticFields.crops && StaticFields.crops.length > 0) {
          this.initialCalls();
          clearInterval(interval);
        }
      }, 800);
    }
    
    window.addEventListener("keydown", function (e) {
      if (e.key === 'f' && e.ctrlKey && (e.target as any).role === 'gridcell') { 
        e.preventDefault();
      }
    });
    window.addEventListener("resize", () => this.setHeight());
    const elements = document.getElementsByClassName("footer-container");
    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.display = 'none';
    }
  }

  initialCalls() {
    this.setHeight();
    //this.showSearch = true;
    this.getSavedSessionsForUser(null);
    if (StaticFields.precodeScreenData && StaticFields.precodeScreenData.crop) {
      this.settingPageLoadData = true;   
      this.setScreenData(false);
    } else if (StaticFields.precodePreference) {
      this.showSearch = StaticFields.precodePreference.flyoutType === 'search';
      this.showSessions = StaticFields.precodePreference.flyoutType === 'sessions';
      this.setScreenData(false);
    }
    this.getUserGridPreferences('managePrecode', false, false);
  }

  setHeight() {
    this.searchHeight = window.innerHeight - 195;
    this.sideBarHeight = `${this.searchHeight + 50}px`;
    let gridHgt = StaticFields.precodeScreenData?.filters && Object.keys(StaticFields.precodeScreenData.filters).length > 0 ? 92 : 100;
    if (window.innerWidth > 1500 && window.innerWidth < 1770 && gridHgt === 92)
      gridHgt = 94;
    if (window.innerWidth > 1770)
      gridHgt = gridHgt === 100 ? gridHgt + 4 : gridHgt + 8;
    // let grdHgt = this.searchHeight - hghtToAdjust - filterBarHeight;
    // this.sideBarMargin = '125px'
    // var sideBarBtn = document.getElementById("sideBarBtn");
    // if (sideBarBtn && sideBarBtn.offsetTop > 120) {
    //   this.sideBarMargin = `${45 + sideBarBtn.parentElement.parentElement.offsetTop}px`;
    //   this.searchHeight = this.searchHeight - 15;
    //   grdHgt = window.innerWidth > 1770 ? grdHgt - 21 : grdHgt - 35;
    // }
    this.gridHeight = `${gridHgt}%`;
  }

  allowEdit(field: string): boolean {
    if (StaticFields.userClaim.isPCMSuperUser)
      return true;
    let programName: string;
    if (field.includes('pstage')) {
       programName = field.split('_')[1];
    } else {
      programName = field.split('_')[0];
    }    
    return StaticFields.userPrograms.findIndex(p => p.cropName == this.selectedCrop.Name && p.code == programName.toUpperCase()) > -1;
    // return StaticFields.userPrograms.includes(programName.toUpperCase());
  }

  getSavedSessionsForUser(selectedSession: string) {
    this.sessions.splice(0);
    let params = new HttpParams();
    params = params.append('appUserId', StaticFields.appUserId);
    this.apiService.getData('GetSavedSessionsForUser', params, false).subscribe((res: any) => {    
      this.sessions = [...res];    
      this.sessionsCopy = JSON.parse(JSON.stringify(res));
      if (selectedSession) {
        StaticFields.precodeScreenData.selSession = this.selSession = this.sessions.find((s: any) => s.name === selectedSession);
      }
    });
  }

  getUserGridPreferences(gridName: string, isSessionSelected: boolean, showLoader: boolean) {
    // if (isSessionSelected) {
    //   this.signalRService.startWebAppConnection(); // for GerMarker Call on load session
    //   this.signalRService.addResponseServerToClientListener();
    // }
    let params = new HttpParams();
    params = params.append('gridName', gridName);
    params = params.append('appUserId', StaticFields.appUserId);
    params = params.append('hasSessionData', isSessionSelected);
    this.apiService.getData('GetUserGridPreferrences', params, showLoader).subscribe((result: any) => {     
      if (isSessionSelected) {
        let existing_Data = result.existingData;
        this.sharedById = existing_Data.sharedByUserId;
        const existingData = JSON.parse(existing_Data.preference);
        if (result.refreshedData?.groupedData) {
          for (let i = 0; i < result.refreshedData.groupedData.length; i++) {
            const data = result.refreshedData.groupedData[i];
            const idx = existingData.data.findIndex((d: any) => d.id === data.id);
            if (idx === -1) {
              existingData.data.splice(0);
              break;
            }
            Object.keys(existingData.data[idx]).filter(k => k.endsWith('_cellColor')).forEach(k => {
              data[k] = existingData.data[idx][k];
            });
            existingData.data.splice(idx, 1);
          }
          if (result.refreshedData.geCount > result.refreshedData.groupedData.length) {
            this.loadingCount = result.refreshedData.geCount;
            this.getDataInBatches({ geIdSet: result.refreshedData.geIdSet, searchData: result.refreshedData.searchData, isSessionData: result.refreshedData.isSessionData, appUserId: result.refreshedData.appUserId, isAddNewRows: result.refreshedData.isAddNewRows, maxAdvGen: result.refreshedData.maxAdvGen, maxPrevGen: result.refreshedData.maxPrevGen, maxSiCnt: result.refreshedData.maxSiCnt }, existingData.data);
          }
          existingData.headerMap = this.headerMap = result.refreshedData.expandCols;
          existingData.data = result.refreshedData.groupedData;
        }        
        StaticFields.precodeScreenData = existingData;
        StaticFields.precodeScreenData.editedData = this.editedData;
        StaticFields.precodeScreenData.selSession = this.selSession;
        if (StaticFields.precodePreference?.headerColorOptions)
          StaticFields.precodeScreenData.headerLegend = JSON.parse(StaticFields.precodePreference.headerColorOptions);

        this.settingPageLoadData = true;
        this.setScreenData(false);
      } else {
        this.userGridPreference = result ? result : new GridPreference();
        if (result) {
          const pref = JSON.parse(result.preference);
          if (pref && pref.cols) {
            this.userGridPreference.wrapHeader = pref.wrapHeader;
            this.userGridPreference.preference = JSON.stringify(pref.cols);
          }
        }
      }
    });
  }
  
  onGridReady($event: GridReadyEvent<any>) {
    this.gridApi = $event.api;
    if (this.settingPageLoadData) {
      if (StaticFields.precodeScreenData.selNodes) {
        if (this.gridApi) {
          const nodesToUpdate: any = [];
          this.gridApi.forEachNode((node: any) => { 
            const selNodes = StaticFields.precodeScreenData.selNodes;
            if (selNodes.find((id: any) => id === node.data.id || id === node.id))
              nodesToUpdate.push(node);
          });
          this.gridApi.setNodesSelected({ nodes: nodesToUpdate, newValue: true });
        }
      }
      if (StaticFields.precodeScreenData.colState && this.showDefaultHeaders === "false")
        this.gridApi.applyColumnState({ state: StaticFields.precodeScreenData.colState, applyOrder: true });
      if (StaticFields.precodeScreenData.filters)
        this.gridApi.setFilterModel(StaticFields.precodeScreenData.filters);
      this.settingPageLoadData = false;
    } else if (this.userGridPreference.preference) {
      this.applySavedColState(JSON.parse(this.userGridPreference.preference), true);
    }
  }

  applySavedColState(savedCols: any, loadFromPref: boolean) {
    if (this.showDefaultHeaders === "true") {
      savedCols.forEach((c: any) => c.width = this.defColWidth);
    }
    let colsToShow: any = [];
    if (this.headerMap) {
      let cols = Object.keys(this.headerMap).filter(key => this.headerMap[key] === 'ge');
      if (!loadFromPref || !this.geLineageChecked)
        savedCols = savedCols.filter((c: any) => !cols.includes(c.colId));
      if (this.geLineageChecked) 
        colsToShow.push(...cols);
      cols = Object.keys(this.headerMap).filter(key => this.headerMap[key] === 'si');
      if (!loadFromPref || !this.seedInventoryChecked)
        savedCols = savedCols.filter((c: any) => !cols.includes(c.colId));
      if (this.seedInventoryChecked)
        colsToShow.push(...cols);
      cols = Object.keys(this.headerMap).filter(key => this.headerMap[key] === 'expt');
      if (!loadFromPref || !this.experimentsChecked)
        savedCols = savedCols.filter((c: any) => !cols.includes(c.colId));
      if (this.experimentsChecked)
        colsToShow.push(...cols);
      cols = Object.keys(this.headerMap).filter(key => this.headerMap[key] === 'pop');
      if (!loadFromPref || !this.popRequestChecked)
        savedCols = savedCols.filter((c: any) => !cols.includes(c.colId));
      if (this.popRequestChecked)
        colsToShow.push(...cols);
      cols = Object.keys(this.headerMap).filter(key => this.headerMap[key].includes('apex'));
      if (!loadFromPref || !this.apexVoteChecked)
        savedCols = savedCols.filter((c: any) => !cols.includes(c.colId));
      if (this.apexVoteChecked)
        colsToShow.push(...cols);
    }
    this.gridApi.applyColumnState({ state: savedCols, applyOrder: true });
    if (colsToShow.length > 0)
      this.gridApi.setColumnsVisible(colsToShow, true);
  }

  onAdvGEGridReady($event: GridReadyEvent<any>) {
    this.advGEGridApi = $event.api;
    const colsToApply: any[] = [];
    const mainGridColState = this.gridApi.getColumnState();
    const gridColState = this.advGEGridApi.getColumnState();
    let colIdx = gridColState.findIndex((c: any) => c.colId === "parent_GEID");
    colsToApply.push(gridColState.splice(colIdx, 1)[0]);
    colIdx = gridColState.findIndex((c: any) => c.colId === "parent_GE_Name");
    colsToApply.push(gridColState.splice(colIdx, 1)[0]);
    gridColState.filter((c: any) => c.colId.startsWith("parent_Pstage")).forEach((p: any) => {
      colIdx = gridColState.findIndex((c: any) => c.colId === p.colId);
      colsToApply.push(gridColState.splice(colIdx, 1)[0]);
    });
    colIdx = gridColState.findIndex((c: any) => c.colId === "child_Count");
    colsToApply.push(gridColState.splice(colIdx, 1)[0]);
    mainGridColState.forEach((col: any) => {
      colIdx = gridColState.findIndex((c: any) => c.colId === col.colId);
      if (colIdx > -1)
        colsToApply.push(gridColState.splice(colIdx, 1)[0]);
    });
    this.advGEGridApi.applyColumnState({ state: colsToApply, applyOrder: true });
  }

  onSessionGridReady($event: GridReadyEvent<any>) {
    this.sessionGridApi = $event.api;
    const nodesToUpdate: any = [];
    this.sessionGridApi.forEachNode((node: any) => { 
      if (node.data.name === this.selSession?.name)
        nodesToUpdate.push(node);
    });
    this.sessionGridApi.setNodesSelected({ nodes: nodesToUpdate, newValue: true });
  }

  changeCrop(isPStage? : boolean, crop? : string) {
    this.geAssessmentsList.splice(0);
    this.selectedAssessments.splice(0);
    this.pStagesList.splice(0);   
    this.pStageData.splice(0);
    this.selectedPStages.splice(0);
    if (!isPStage)
      this.selectedInclusions = this.selectedStages =this.selectedYears = null;
    if (this.selectedCrop) {
      this.getMasterData(isPStage,crop);  
      if (!isPStage)  
        this.getMetaData();
      if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId && StaticFields.precodePreference.crop === this.selectedCrop.Name)
        this.setScreenData(true);
    }
  }

  changeLevel() {
    this.selectedInclusions = null;
    if (this.selectedLevel.name === "Program(s)") {
      this.inclusions = this.programs.map((d: any) => { return {id: d.id, code: d.code, desc: d.description};});
      this.inclusionsCopy = this.programs.map((d: any) => { return {id: d.id, code: d.code, desc: d.description};});
    } else if (this.selectedLevel.name === "Region(s)") {
      this.inclusions = this.regions.map((d: any) => { return {code: d.Code, desc: d.Description};});
    } else if (this.selectedLevel.name === "EZ(s)") {
      this.inclusions = this.ezs.map((d: any) => { return {code: d.code, desc: d.description};});
    } else if (this.inclusions)
      this.inclusions.splice(0);
    if (this.settingPageLoadData && StaticFields.precodeScreenData && StaticFields.precodeScreenData.include) {
      this.selectedInclusions = this.inclusions.filter(i => StaticFields.precodeScreenData.include.includes(i.code));
      this.selectedStages = StaticFields.precodeScreenData.stage;
      this.selectedYears = StaticFields.precodeScreenData.years;
      this.headerMap = StaticFields.precodeScreenData.headerMap;
      this.rowData = StaticFields.precodeScreenData.data;
      this.editedData = StaticFields.precodeScreenData.editedData;
      this.selColor = StaticFields.precodeScreenData.selectedColor;
      this.rowDataCopy = JSON.parse(JSON.stringify(this.rowData));
      if (StaticFields.precodeScreenData.selSession) {
        this.selSession = StaticFields.precodeScreenData.selSession;
        this.sessionName = this.selSession.name;
       // this.sessionGridApi.api.forEachNode((node: any)=> node.rowIndex ? 0 : node.setSelected(true));      
      }
      this.createDynamicCols(this.gridOptions, this.gridColDef, this.rowData, false);
      this.showSearch = false;
    } else if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId && this.inclusions.length > 0) {
      if (this.selectedCrop.Name === StaticFields.precodePreference.crop) {
        const inclPredicate = StaticFields.precodePreference.include.split(",").some(ele => this.inclusions.findIndex((i: any) => i.code === ele) > -1);
        const stagePredicate = StaticFields.precodePreference.stage.split(",").some(ele => this.stages.includes(ele));
        const selInclusions = inclPredicate && StaticFields.precodePreference.include!= "" && StaticFields.precodePreference.include.split(",").length > 0 ? StaticFields.precodePreference.include.split(",") : [];
        this.selectedStages = stagePredicate &&  StaticFields.precodePreference.stage!= "" && StaticFields.precodePreference.stage.split(",").length > 0 ? StaticFields.precodePreference.stage.split(",") : [];
        this.selectedInclusions = this.inclusions.filter(i => selInclusions.includes(i.code));
      }
      if (!this.showSearch) {
        this.showSearch = StaticFields.precodePreference.flyoutType === 'search';
        this.showSessions = StaticFields.precodePreference.flyoutType === 'sessions';
      }
    }
  }

  getRegionsPrograms(isPStage ?:  boolean, crop? : string) {
    let params = new HttpParams();
    const cropId = isPStage ? this.crops.find(ele => ele.Name === crop).Id : this.selectedCrop.Id;
    params = params.append('cropId', cropId);
    this.apiService.getRADData(`Regions?$filter=CropId eq ${cropId} and Status/Name eq 'Active'&$select=Id,Code,Description`, false).subscribe((result : any) => {
      if (result.value.findIndex((v: any) => v.Code.toUpperCase() === 'WW') === -1)
        result.value.push({Code: 'WW', Description: 'Worldwide'});
      result.value = result.value.sort((a: any , b: any) => a.Code.localeCompare(b.Code));  
      if(!isPStage) {
        this.regions = result.value;
        this.loader.clearMessage();
        if (this.selectedLevel && this.selectedLevel.name === "Region(s)")
          this.changeLevel();
        } else {
          this.pStageRegions = result.value;
          this.loader.clearMessage();
        }     
    });
    // this.apiService.getRADData(`EvaluationZones?$filter=CropId eq ${cropId} and Status/Name eq 'Active'&$select=Id,Code,Description`, false).subscribe((result : any) => {
    //     result.value = result.value.sort((a: any , b: any) => a.Code.localeCompare(b.Code));
    //     if(!isPStage) {
    //       this.ezs = result.value;
    //       this.loader.clearMessage();
    //       if (this.selectedLevel && this.selectedLevel.name === "EZ(s)")
    //         this.changeLevel();
    //     }
    //     else {
    //       this.pStageEzs = result.value;
    //       this.loader.clearMessage();
    //     }     
    // });
    this.getEvaluationZonePreference(isPStage);    
    this.getProgramPreference(isPStage);
  }

  getEvaluationZonePreference(isPStage: boolean = false) {   
    this.apiService.getOData(`EvaluationZonePreferences?$filter=CropName eq '${this.selectedCrop.Name}' and IsActive&$select=Id,Code,Description`).subscribe((result : any) => {  
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)); 
      if(!isPStage) {
        this.ezs = result.value;
        this.loader.clearMessage();
        if (this.selectedLevel && this.selectedLevel.name === "EZ(s)")
          this.changeLevel();
      }
      else {
        this.pStageEzs = result.value;
        this.loader.clearMessage();
      }       
    });
  }

  getProgramPreference(isPStage: boolean = false){
    //this.apiService.getRADData(`Programs?$filter=CropId eq ${cropId} and Status/Name eq 'Active'&$select=Id,Code,Description`, false).subscribe((result : any) => {
    let selectCountry = '';
    if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
      selectCountry = ',CountryName';
    this.apiService.getOData(`ProgramPreferences?$filter=CropName eq '${this.selectedCrop.Name}'and IsActive&$select=Id,Code,Description${selectCountry}`).subscribe((result : any) => {
      if (StaticFields.countriesToShow && StaticFields.countriesToShow.length > 0)
        result.value = result.value.filter((r: any) => StaticFields.countriesToShow.includes(r.countryName.toUpperCase()));
      result.value = result.value.sort((a: any , b: any) => a.code.localeCompare(b.code)); 
      if (!isPStage) {
        this.programs = result.value;
        this.loader.clearMessage();
        if (this.selectedLevel && this.selectedLevel.name === "Program(s)")
          this.changeLevel();
      }
      else {
        this.pStagePrograms = result.value;
        this.loader.clearMessage();
      }    
    });
  } 

  getMasterData(isPStage? : boolean, crop? : string) {
    if(!isPStage) {
      this.allStageValues = StaticFields.masterData?.filter(p => p.type == 'Stage' && p.crop == this.selectedCrop.Name && p.isActive); 
      this.stages = this.allStageValues.map((s: any) => s.stage);
    }
    this.getRegionsPrograms(isPStage,crop);      
  }

  
  getMetaData() {   
    this.metaDataList = StaticFields.metaData?.filter(p => (p.crop.toUpperCase() === "ALL" || p.crop === this.selectedCrop.Name) && p.isActive).map((d: any) => d.name).sort((a: any, b: any) => (a > b) ? 1 : ((b > a) ? -1 : 0));
    this.tagList.splice(0);
    if (StaticFields.precodePreference?.tags) {
      const tagParts = StaticFields.precodePreference.tags.split(";");
      tagParts.forEach((t: any) => {
        const parts = t.split(':');
        if (parts[1] === 'true')
          this.tagList.push(parts[0]);
      });
    } 
  }

  setSearchData(expandBy: string) {
    let postData : any = {};
    postData['crop'] = this.selectedCrop.Name;
    postData['level'] = this.selectedLevel.name;
    postData['include'] = this.selectedInclusions.map((i: any) => i.code).join();
    postData['stage'] = this.selectedStages ? this.selectedStages.join() : '';
    postData['years'] = this.selectedYears ? this.selectedYears.join() : '';
    postData['expandBy'] = expandBy;
    //postData['genToFetch'] = this.genToFetch.val;
    postData['stageInfoToFetch'] = [];
    this.selectedPStages.forEach((ele : any) => {     
      const type = ele.type === 'EZ(s)' ? 'EZ' : ele.type == 'Region(s)' ? 'Region' :'PRG';
      const names = ele.name.split(",");  
      const years = ele.year.split(","); 
      names.forEach((name : any) => {
        years.forEach((year : any) => {
          postData['stageInfoToFetch'].push({
            settingType: ele.settingType,
            type: type,
            name : name,
            year: year,
            pStage:'',
            crop: ele.crop
          });
        });
      });
    });
    this.selectedAssessments.forEach(ele => { ele.aois = ele.years = null; });    
    postData['geAssessments'] = this.selectedAssessments;
    return postData;
  }

  SearchData(isAppendSession: boolean) {
    this.showSessions = this.showSearch = false;
    const expandBy = this.getExpandOptions();
    // this.rowData.splice(0);
    // this.rowDataCopy.splice(0);
    
    // postData['geAssessments'] = [];
    // this.selectedAssessments.forEach((ele: any) => {
    //   postData['geAssessments'].push({key: ele.traitId, value: ele.traitName});
    // });
    const postData = this.setSearchData(expandBy);
    postData.userCountry = StaticFields.userInfo.country;
    if (isAppendSession) {
      postData['isAppendSession'] = isAppendSession;    
      postData['selectedGeIds'] = this.rowData.map((ele: any) => ele.geid);    
      postData['sessionName'] = this.sessionName;
      postData['appUserId'] = StaticFields.appUserId;    
    }
    else {
      this.selSession = null;
      this.sessionName = '';
    }
    this.existingGridColors.splice(0);  
    this.rowData.splice(0);
    this.rowDataCopy.splice(0);  
    this.editedData = {};    
    // this.signalRService.startWebAppConnection();
    // this.signalRService.addResponseServerToClientListener();
    this.apiService.postData('SearchPreCodes', postData, false, true).subscribe((result : any) => {
      if (result && result.groupedData && result.groupedData.length > 0) {
        if (result.geCount > result.groupedData.length) {
          this.confirmationService.confirm({
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            message: `Total ${result.geCount} rows found. ${result.groupedData.length} rows have been loaded. Remaining data will be loaded in batches of 10000. Do you want to continue?`,
            accept: () => {
              this.loadingCount = result.geCount;
              this.getDataInBatches({ geIdSet: result.geIdSet, searchData: result.searchData, isSessionData: result.isSessionData, appUserId: result.appUserId, isAddNewRows: result.isAddNewRows, maxAdvGen: result.maxAdvGen, maxPrevGen: result.maxPrevGen, maxSiCnt: result.maxSiCnt }, null);
            },
            reject: () => {
              this.customMessageService.showMessage({'severity': 'info', summary: 'Canceled', detail: 'Data Fetch Canceled.' }); 
            }
          });
        }
        this.headerMap = result.expandCols;
        this.rowDataCopy = JSON.parse(JSON.stringify(result.groupedData));
        this.createDynamicCols(this.gridOptions, this.gridColDef, result.groupedData, false);
        const precodeData: any = new Object();
        precodeData.data = this.rowData = result.groupedData;
        precodeData.crop = this.selectedCrop;
        precodeData.headerMap = this.headerMap;
        precodeData.level = this.selectedLevel;
        precodeData.include = this.selectedInclusions.map((i: any) => i.code);
        precodeData.stage = this.selectedStages;
        precodeData.years = this.selectedYears;
        precodeData.expandBy = expandBy;
        precodeData.geAssessmentsList = this.geAssessmentsList;
        precodeData.pStageData = this.pStageData;
        precodeData.pStagesList = this.pStagesList;
        precodeData.selectedAssessmentsList = this.selectedAssessments;
        precodeData.selectedPStages = this.selectedPStages
        precodeData.isFavouriteSelected = this.favProgramsChecked;
        if (StaticFields.precodePreference?.headerColorOptions)
          this.headerLegend = JSON.parse(StaticFields.precodePreference.headerColorOptions);
        precodeData.headerLegend = this.headerLegend
        StaticFields.precodeScreenData = precodeData;
        StaticFields.precodeScreenData.editedData = this.editedData;
        this.applyHeaderLegend();       
      } else
        this.customMessageService.showMessage({'severity': 'warn', summary: 'No Data', detail: 'No Data Found' });     
    });
  }

  public cancelBatchJobs() {
    this.cancelBatch = true;
    this.loadingCount = 0;
    this.customMessageService.showMessage({'severity': 'info', summary: 'Canceled', detail: 'Data Fetch Canceled.' }); 
  }

  private getDataInBatches(batchData: any, sessionData: any, errCnt: number = 0) {
    const remainingGeIds = batchData.geIdSet;
    batchData.geIdSet = remainingGeIds.splice(0, 10000);
    this.apiService.postData('GetDataInBatches', batchData, false, false, true).subscribe({
      next: (result) => {
        if (result && result.groupedData) {
          if (!this.cancelBatch) {
            if (result.maxAdvGen > batchData.maxAdvGen || result.maxPrevGen < batchData.maxPrevGen || result.maxSiCnt > batchData.maxSiCnt) {
              this.headerMap = result.expandCols;
              this.createDynamicCols(this.gridOptions, this.gridColDef, result.groupedData, false);
              this.gridApi.setGridOption("columnDefs", this.gridColDef);
            }
            if (sessionData) {
              for (let i = 0; i < result.groupedData.length; i++) {
                const data = result.groupedData[i];
                const idx = sessionData.findIndex((d: any) => d.id === data.id);
                if (idx === -1)
                  break;
                Object.keys(sessionData[idx]).filter(k => k.endsWith('_cellColor')).forEach(k => {
                  data[k] = sessionData[idx][k];
                });
                sessionData.splice(idx, 1);
              }
            }
            StaticFields.precodeScreenData.data = result.groupedData.concat(StaticFields.precodeScreenData.data);
            this.rowData = this.rowData.concat(result.groupedData);
            this.rowDataCopy = this.rowDataCopy.concat(JSON.parse(JSON.stringify(result.groupedData)));
            const res = this.gridApi!.applyTransaction({
              add: result.groupedData,
              addIndex: 0,
            })!;
            result.groupedData = result.expandCols = null;
          }
          if (this.loadingCount > this.rowData.length && !this.cancelBatch) {
            result.geIdSet = remainingGeIds;
            this.getDataInBatches(result, sessionData);
          } else {
            this.cancelBatch = false;
            this.loadingCount = 0;
            //this.loadMarkerData(this.rowData, false);
          }
        }
      },
      error: (err) => {
        if (err.status && errCnt < 3 && !this.cancelBatch) {
          errCnt++;
          return this.getDataInBatches(batchData, sessionData, errCnt);
        } else {
          this.cancelBatch = false;
          this.loadingCount = 0;
          this.apiService.errorHandler('GetDataInBatches', err, batchData);
        }
      }
    });
  }

  // private loadMarkerData(rowData: any[], isadvGE: boolean) {
  //   if (!isadvGE && rowData[0]['observed_Marker_Count'] === null && this.loadingCount === 0) {     
  //     const geIdList = rowData.map((d: any) => d.geid);
  //     const postData = {geIdList: geIdList, signalRConnectionId: SignalRService.SignalRConnectionId }
  //     this.apiService.postData('GetMarkerCount', postData, false, false).subscribe();      
  //     // this.apiService.postData('GetMarkerCount', postData, false, false).subscribe((result : any) => {
  //     //   rowData.forEach((d: any) => {
  //     //     const markerCounts = result[d.geid].split(',');
  //     //     d.observed_Marker_Count = Number(markerCounts[0]);
  //     //     d.imputed_Marker_Count = Number(markerCounts[1]);
  //     //   });
  //     //   this.gridApi.refreshCells({columns: ['observed_Marker_Count','imputed_Marker_Count']});
  //     // });
  //   }
  // }

  private createDynamicCols(gridOptions: any, coldef: any[], rowData: any[], isadvGE: boolean) {
    let wrapHeader = false;
    if (this.userGridPreference && this.userGridPreference.wrapHeader !== null && this.userGridPreference.wrapHeader !== undefined)
      wrapHeader = this.userGridPreference.wrapHeader;
    else if (StaticFields.precodePreference)
      wrapHeader = StaticFields.precodePreference.wrapHeader === null ? true : StaticFields.precodePreference.wrapHeader;
    this.wrapHeader = gridOptions.defaultColDef.wrapHeaderText = gridOptions.defaultColDef.autoHeaderHeight = wrapHeader;
    //this.loadMarkerData(rowData, isadvGE);
    
    coldef.splice(0);
    if (!isadvGE)
      coldef.push({ headerName: '__', field: 'selected', pinned: 'left', checkboxSelection: true, headerCheckboxSelection : true, headerCheckboxSelectionFilteredOnly: true, suppressFiltersToolPanel: true, lockPosition: "left", suppressHeaderFilterButton: true,suppressHeaderMenuButton: true, resizable: false, width:25, suppressColumnsToolPanel: true,
        comparator: (valueA: any, valueB: any, nodeA: any, nodeB: any) => {
          if (nodeA.selected == nodeB.selected) return 0;
          return nodeA.selected ? -1 : 1;
      } })
    const metaDataCols: string[] = [];
    const tagCols: string[] = [];
    let hideCol = false;
    const headerMap = isadvGE ? this.childGridHeaderMap : this.headerMap;
    let def: any;
    this.bulkEditPrgs.splice(0);
    this.bulkYears.splice(0);
    Object.keys(rowData[0]).forEach(k => {
      if (!isadvGE && k !== 'id' && k !== 'expt_YrSsn' && !k.includes('_cellColor') || (isadvGE && k !== 'crop')) {
        const allowEdit = (k.includes('pstage') || k.includes('MetaData')  || k.includes('Tag') || (k.includes('Comments') && !k.includes('seed_Comments'))) && !(k.includes("Region") || k.includes("EZ"));
        if (allowEdit) {
          if (k.includes('pstage')) {
            def = { field: k, headerName: this.capitalizeHeader(k, false), headerTooltip : k, editable: this.allowEdit(k), 
              cellEditor: 'agSelectCellEditor', cellEditorParams: (params: any) => { return { values: ["", ...this.stages] }; } };
            const parts = k.split('_');
            const prgName = parts[1];
            if (!this.bulkEditPrgs.includes(prgName.toUpperCase()))
              this.bulkEditPrgs.push(prgName.toUpperCase());
            const yr = Number(parts[2]);
            if (!this.bulkYears.includes(yr))
              this.bulkYears.push(yr);
          } else if (k.includes('MetaData')) {
            metaDataCols.push(k);
            def = { field: k, headerName: this.capitalizeHeader(k, true),  headerTooltip : k, editable: this.allowEdit(k), cellEditor: 'customMultiSelectEditor',
              cellEditorParams: (params : any ) => {
                return {values:this.metaDataList, dataSourceType: "years", separator: ','}
              },
              suppressKeyboardEvent: (params : any) => {
                const key = params.event.key;
                const gridShouldDoNothing = params.editing && (key === "Enter");
                return gridShouldDoNothing;
              }
            };
          } else if (k.includes('Tag')) {
            tagCols.push(k);
            def = { field: k, headerName: this.capitalizeHeader(k, true) + 's', headerTooltip: k, editable: this.allowEdit(k), cellEditor: 'customMultiSelectEditor',
              cellEditorParams: (params : any ) => {
                return {values: this.tagList, dataSourceType: "years", separator: ';'}
              },
              suppressKeyboardEvent: (params : any) => {
                const key = params.event.key;
                const gridShouldDoNothing = params.editing && (key === "Enter");
                return gridShouldDoNothing;
              } 
            };            
          } else 
            def = { field: k, headerName: this.capitalizeHeader(k, true), headerTooltip: k, editable: this.allowEdit(k) };
        } else {
          //let width = (k === "crop" || k === "geid" || k === "hetgrp") ? 110 : 150;
          if (k === "geid" || k === "gE_Name")
            def = { field: k, headerName: k === 'geid' ? 'GEID' : 'GE_Name', headerTooltip : k, pinned: "left" };
          else {
            let header = k;
            hideCol = false;
            if (k === 'hetgrp' || k === 'sapr' || k.toLowerCase().includes('siid') || k.toLowerCase().includes('ssl') || k.toLowerCase().includes('uot'))
              header = k.toUpperCase();
            else
              header = this.capitalizeHeader(k, false);
            if (headerMap[k]) {
              if (headerMap[k].includes('apex') || headerMap[k] === 'trait' || headerMap[k].toLowerCase().includes('program:'))
                header = this.capitalizeHeader(k, true);
              hideCol = true;
              if (headerMap[k] === 'ge' || headerMap[k] === 'si' || headerMap[k] === 'pop' || headerMap[k] === 'expt' || headerMap[k].includes('apex')) {
                if (this.geLineageChecked && headerMap[k] === 'ge')
                  hideCol = false;
                if (this.seedInventoryChecked && headerMap[k] === 'si')
                  hideCol = false;
                if (this.popRequestChecked && headerMap[k] === 'pop')
                  hideCol = false;
                if (this.experimentsChecked && headerMap[k] === 'expt')
                  hideCol = false;
                if (this.apexVoteChecked && headerMap[k].includes('apex'))
                  hideCol = false;
              } else
                hideCol = false;
            }
            def = { field: k, headerName: header, headerTooltip : k, hide: hideCol };
          }
          if (k === 'observed_Marker_Count' || k === 'imputed_Marker_Count' || k === 'childs_With_PStage' || k === 'req_Id' || k === 'req_Target' || k.toLowerCase().includes('count') || k.includes('siid') || k.includes('weight') || k.includes('growing_F_EUID') || k.includes('growing_Location_Year') || k === 'p1_RM' || k === 'p2_RM' || k === 'geid' || k === 'parent_GeId') {
            def.filterParams = {
              filters: [
                {
                  filter: ColorFilter
                },
                {
                  filter: "agNumberColumnFilter",
                  filterParams: { buttons: ["clear"] }
                },
              ],
              refreshValuesOnOpen: true
            } as IMultiFilterParams;
          }
        }
        coldef.push(def);
      }
    });
    // rowData.forEach(ele => {
    //   metaDataCols.forEach(col => {
    //     ele[col] = ele[col] && !Array.isArray(ele[col]) ? ele[col].split(",") : Array.isArray(ele[col]) ? ele[col] : [];
    //   });
    //   tagCols.forEach(col => {
    //     ele[col] = ele[col] && !Array.isArray(ele[col]) ? ele[col].split(";") : Array.isArray(ele[col]) ? ele[col] : [];
    //   });
    // });
  }

  // resetMarkerCountAfterSignalRResponse(result: any) {
  //   this.rowData.forEach((d: any) => {
  //     const markerCounts = result[d.geid].split(',');
  //     d.observed_Marker_Count = Number(markerCounts[0]);
  //     d.imputed_Marker_Count = Number(markerCounts[1]);
  //   });
  //   if (this.gridApi)
  //     this.gridApi.refreshCells({columns: ['observed_Marker_Count','imputed_Marker_Count']});
  // }

  capitalizeHeader(header: string, splitNCapitalize: boolean) {
    if (splitNCapitalize) {
      const parts = header.split('_');
      parts[0] = parts[0].toUpperCase();
      return parts.join('_');
    }
    return header.charAt(0).toUpperCase() + header.slice(1);
  }

  getExpandOptions() {
    const expandBy: string[] = [];
    if (this.geLineageChecked)
      expandBy.push('GE');
    if (this.seedInventoryChecked)
      expandBy.push('SI');
    if (this.popRequestChecked)
      expandBy.push('POP');
    if (this.experimentsChecked)
      expandBy.push('EXPT');
    if (this.apexVoteChecked)
      expandBy.push('APEX');
    return expandBy.join();
  }

  setExpandOptions(expandBy: string[]) {
    this.geLineageChecked = this.experimentsChecked = this.seedInventoryChecked = this.popRequestChecked = this.apexVoteChecked = false;
    expandBy.forEach(item => {
      if (item === 'GE')
        this.geLineageChecked = true;
      else if (item === 'SI')
        this.seedInventoryChecked = true;
      else if (item === 'POP')
        this.popRequestChecked = true;
      else if (item === 'EXPT')
        this.experimentsChecked = true;
      else if (item === 'APEX')
        this.apexVoteChecked = true;
    });
  }

  saveGridPreferences() {
    if (!this.userGridPreference.appUserId) {
      this.userGridPreference.appUserId = StaticFields.appUserId;
      this.userGridPreference.gridName= "managePrecode";
    }
    this.userGridPreference.wrapHeader = this.gridOptions.defaultColDef.wrapHeaderText;
    this.userGridPreference.preference = JSON.stringify(this.gridApi.getColumnState());
    this.apiService.putData('SubmitUserGridPreference', this.userGridPreference).subscribe();
  }

  openCopyRowsModal() {
    this.sessionCopyName = '';
    this.sessionType = 'SaveNewSession';
    this.sessionDesc = '';
    this.showCopyModal = true; 
  }

  copyToSessionAfterConfirming(updateForAll: boolean) {
    const selRows = this.gridApi.getSelectedRows();
    this.loader.setMessage("Loading...");
    if (this.sessionNames.includes(this.sessionCopyName)) {
      let params = new HttpParams();
      params = params.append('gridName', this.sessionCopyName);
      params = params.append('appUserId', StaticFields.appUserId);
      params = params.append('hasSessionData', false);
      this.apiService.getData('GetUserGridPreferrences', params, false).subscribe((res: any) => {
        const existingData = JSON.parse(res.preference);
        if (existingData.crop.Name !== StaticFields.precodeScreenData.crop.Name) {
          this.loader.clearMessage();
          this.customMessageService.showMessage({severity: 'warn', summary:'Crop Mismatch' , detail: `Crop of selected session is ${existingData.crop.Name}, can't save.`});
          return;
        }
        selRows.forEach((r: any) => { 
          if (existingData.data.findIndex((d: any) => d.id === r.id) === -1) {
            const data: any = {};
            data.id = r.id;
            Object.keys(r).filter(k => k.endsWith('_cellColor')).forEach(k => {
              data[k] = r[k];
            });
            existingData.data.push(data);
            res.geCount++;
          }
        });
        res.preference = JSON.stringify(existingData);
        const submitData = { preference: res, updateAll: updateForAll };
        this.copyMoveDatatoSession(submitData);
      });
    } else {
      const screenData = JSON.parse(JSON.stringify(StaticFields.precodeScreenData));
      screenData.data = selRows;
      const submitData = this.createSubmitDataForSession(screenData, updateForAll);
      this.copyMoveDatatoSession(submitData);
    }
  }

  copyMoveDatatoSession(submitData: any) {
    this.apiService.putData('SaveSession', submitData).subscribe((res: any) => {
      this.loader.clearMessage();
      
      this.showCopyModal = false;
      if (this.copyType === 'move') {
        this.removeRows(null, 'selRows');
        if (this.sessionName) {
          this.saveSession();
        } else {
          this.getSavedSessionsForUser(null);
          this.newPStageIds.splice(0);
        }
      } else {
        this.getSavedSessionsForUser(null);
        this.newPStageIds.splice(0);
      }
    });
  }

  savePageState() {
    this.sessionType = this.sessionName ? 'UpdateSession' : 'SaveNewSession';
    this.sessionDesc = '';
    this.showSaveModal = true;    
  }

  saveSession() {
    if (this.showCopyModal && this.sessionCopyName === this.sessionName) {
      this.customMessageService.showMessage({severity: 'warn', summary:'Same Session' , detail: 'Cannot copy to the same session.'});
      return;
    }
    const selSession = this.showCopyModal ? this.sessions.find((s: any) => s.name === this.sessionCopyName) : this.sessions.find((s: any) => s.name === this.sessionName);
    if (selSession && (selSession.count > 0 || selSession.sharedBy)) {
      const msg = selSession.count > 0 ? `Session: ${selSession.name} is shared with ${selSession.count} user(s). Do you want to update for everyone?` : `Session: ${selSession.name} was shared with you. Do you want to update for everyone?`;
      this.confirmationService.confirm({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: msg,   
        acceptLabel: 'Update for All',
        rejectLabel: 'Update for Me',
        acceptIcon: "none",
        rejectIcon: "none",
        accept: () => {
          this.showCopyModal ? this.copyToSessionAfterConfirming(true) : this.saveSessionAfterConfirming(true);
        },
        reject: () => {
          this.showCopyModal ? this.copyToSessionAfterConfirming(false) : this.saveSessionAfterConfirming(false);
        }
      });
    } else
      this.showCopyModal ? this.copyToSessionAfterConfirming(false) : this.saveSessionAfterConfirming(false);   
  }

  saveSessionAfterConfirming(updateForAll: boolean) {
    const submitData = this.createSubmitDataForSession(StaticFields.precodeScreenData, updateForAll);
    this.apiService.putData('SaveSession', submitData).subscribe((res: any) => {
      this.getSavedSessionsForUser(this.sessionName);
      this.newPStageIds.splice(0);
      this.showSaveModal = false;
    });
  }

  createSubmitDataForSession(screenData: any, updateForAll: boolean) {
    let pageState: GridPreference = new GridPreference();
    pageState.appUserId = StaticFields.appUserId;
    pageState.gridName = this.showCopyModal ? this.sessionCopyName : this.sessionName;
    pageState.sessionDescription = this.sessionDesc;
    screenData.expandBy = this.getExpandOptions();
    screenData.colState = this.gridApi.getColumnState();
    pageState.geCount = screenData.data.length;
    
    let requestData = JSON.parse(JSON.stringify(screenData));
    const ids: any = [];
    requestData.data.forEach((d: any) => {
      const data: any = {};
      data.id = d.id;
      Object.keys(d).filter(k => k.endsWith('_cellColor')).forEach(k => {
        data[k] = d[k];
      });
      ids.push(data);
      // Object.keys(this.headerMap).forEach((k: string) =>
      //   delete d[k]
      // );
    });
    requestData.data = ids;
    pageState.preference = JSON.stringify(requestData);
    pageState.isSession = true;
    pageState.sharedByUserId = this.sharedById;
    return { preference: pageState, updateAll: updateForAll };
  }

  deleteSessions() {
    const sessionsToDel = this.sessionGridApi.getSelectedRows().map((s: any) => s.name);
    let sharedSessionsCount = 0;
    sessionsToDel.forEach((sessionToDel: string) => {
      if (this.sessions.find((s: any) => s.name === sessionToDel).count > 0)
        sharedSessionsCount++;
    });
    if (sharedSessionsCount > 0) {
      const msg = sharedSessionsCount === 1 ? 'Session is' : 'Sessions are';
      
        this.confirmationService.confirm({
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          message: `${sharedSessionsCount} ${msg} shared with other users. Do you want to delete for everyone?`,   
          acceptLabel: 'Delete for All',
          rejectLabel: 'Delete for Me',
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            setTimeout(() => {
              this.deleteSessionAfterConfirming(true, sessionsToDel.join());
            }, 600);
          },
          reject: () => {
            setTimeout(() => {
              this.deleteSessionAfterConfirming(false, sessionsToDel.join());
            }, 600);
          }
        });
      
    } else
      this.deleteSessionAfterConfirming(false, sessionsToDel.join());
  }

  deleteSessionAfterConfirming(deleteForAll: boolean, sessionNames: string) {
    this.confirmationService.confirm({
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      message: `Are you sure you want to delete Session(s): ${sessionNames}?`,     
      accept: () => {
        const idsToRemove = this.sessionGridApi.getSelectedRows().map((s: any) => s.id);
        const submitData = { ids: idsToRemove, appUserId: StaticFields.appUserId, deleteForAll: deleteForAll };
        this.apiService.putData('DeleteSessions', submitData).subscribe((result : any) => {    
          let resetPref = false;
          idsToRemove.forEach((id: string) => {
            this.sessions.splice(this.sessions.findIndex((s: any) => s.id === id), 1);
            if (this.selSession && this.selSession.id === id) {
              this.selSession = null;
              resetPref = true;
            }
          });
          const data = this.sessions.splice(0);
          this.sessions = [...data];
          this.sessionsCopy = JSON.parse(JSON.stringify(this.sessions));
          if (resetPref) {
            this.resetSearchByPreference();
          }
        });
      }
    });
  }

  updateSessions() {
    let sharedSessionsCount = 0;
    
    const sessionsToUpdate: any = [];
    this.sessions.forEach((s: any) => {
      if (this.sessionsCopy.findIndex((sc: any) => sc.name === s.name && sc.sessionDescription === s.sessionDescription) === -1) {
        const data: any = {};
        data.id = s.id;
        data.appUserId = StaticFields.appUserId;
        data.gridName = s.name;
        data.sessionDescription = s.sessionDescription;
        data.preference = '';
        sessionsToUpdate.push(data);
        if (s.count > 0)
          sharedSessionsCount++;
      }
    });
    if (sharedSessionsCount > 0) {
      const msg = sharedSessionsCount === 1 ? 'Session is' : 'Sessions are';
      setTimeout(() => {
        this.confirmationService.confirm({
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          message: `${sharedSessionsCount} ${msg} shared with other users. Do you want to update for everyone?`,   
          acceptLabel: 'Update for All',
          rejectLabel: 'Update for Me',
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            this.updateSessionAfterConfirming(sessionsToUpdate, true);
          },
          reject: () => {
            this.updateSessionAfterConfirming(sessionsToUpdate, false);
          }
        });
      }, 600);
    } else
      this.updateSessionAfterConfirming(sessionsToUpdate, false);
  }

  updateSessionAfterConfirming(sessionsToUpdate: any, updateForAll: boolean) {
    const submitData = { sessions: sessionsToUpdate, appUserId: StaticFields.appUserId, updateForAll: updateForAll };
    this.apiService.putData('UpdateSessions', submitData).subscribe((result : any) => {  
      this.getSavedSessionsForUser(this.sessionName);
    });
  }

  resetSearch() {
    if(!this.cropReset) {
      this.confirmationService.confirm({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: `Are you sure you want to reset the screen?`,
        accept: () => {
          this.resetSearchByPreference();
        }
      });
    } else {
      this.selectedCrop = this.selectedLevel = this.selectedInclusions = this.selectedStages = this.selectedYears = null;
      this.geLineageChecked = this.popRequestChecked = this.experimentsChecked = this.seedInventoryChecked = this.apexVoteChecked = false;
      this.setDefaultValues();
      this.cropReset = false;
      this.showSearch = StaticFields.precodePreference?.flyoutType === 'search';
      this.showSessions = StaticFields.precodePreference?.flyoutType === 'sessions';
    }
  }

  setDefaultValues() {
    this.selColor = '#ffffff';
    this.selSession = null;
    this.sessionName = '';
    this.rowData.splice(0);
    this.rowDataCopy.splice(0);
    this.favProgramsChecked = false;
    this.editedData = {};
    //this.genToFetch = {name: "0", val : 0};
  }

  resetSearchByPreference() {
    this.setDefaultValues();
    StaticFields.precodeScreenData = null;
    if (StaticFields.precodePreference && StaticFields.precodePreference.appUserId) {
      this.showSearch = StaticFields.precodePreference.flyoutType === 'search';
      this.showSessions = StaticFields.precodePreference.flyoutType === 'sessions';
      this.setScreenData(false);
    } else {
      this.selectedCrop = this.selectedLevel = this.selectedInclusions = this.selectedStages = this.selectedYears = null;
      this.geLineageChecked = this.popRequestChecked = this.experimentsChecked = this.seedInventoryChecked = this.apexVoteChecked = false;
      this.showSearch = this.showSessions = false;
    }
  }

  navigateToCode() {
    this.programsToCode.splice(0);
    this.yearsToCode.splice(0);
    this.selectedPStages.forEach((ele : any) => {
      if (ele.settingType == "PStage" && ele.type == "Program(s)") {
        this.programsToCode = [...new Set([...this.programsToCode,...ele.name.split(",")])];
        this.yearsToCode = [...new Set([...this.yearsToCode,...ele.year.split(",")])];
      }
    });
    if (this.programsToCode.length === 1 && this.yearsToCode.length === 1){
      this.selectedCodeProgram = this.programsToCode[0];
      this.selectedCodeYear = this.yearsToCode[0];
      this.sendToCode();
    }
    else
      this.confirmCodeSearch = true;
  }

  cancelNavigateToCode() {
    this.confirmCodeSearch = false;
  }

  sendToCode() {
    const geIds = this.gridApi.getSelectedRows().map((ele: any) => ele.geid);
    setTimeout(() => {
      this.router.navigate(['/code'], {queryParams : {selectedGes: geIds,crop: this.selectedCrop.Name, selectedProgram : this.selectedCodeProgram, selectedYear : this.selectedCodeYear}});
    },300);
  }

  expandChildren() {
    const selRows = this.gridApi.getSelectedRows().filter((r: any) => r.child_Count > 0);
    if (selRows.length === 0) {
      this.customMessageService.showMessage({severity: 'warn', summary:'No Child rows found' , detail: 'Selected rows do not have any children. Only Child rows can be expanded.'});
      return;
    }
    let postData : any = {};
    postData['crop'] = this.selectedCrop.Name;
    postData['level'] = "";
    postData['include'] = "";
    postData['expandBy'] = this.getExpandOptions();
    postData['selectedGeIds'] = selRows.map((ele: any) => ele.geid);
    postData['stageInfoToFetch'] = [];
    this.selectedPStages.forEach((ele : any) => {
      const type = ele.type === 'EZ(s)' ? 'EZ' : ele.type == 'Region(s)' ? 'Region' :'PRG';
      const names = ele.name.split(",");  
      const years = ele.year.split(","); 
      names.forEach((name : any) => {
        years.forEach((year : any) => {
          postData['stageInfoToFetch'].push({
            settingType: ele.settingType,
            type: type,
            name : name,
            year: year,
            pStage:'',
            crop: ele.crop
          });
        });
      });
    });
    this.selectedAssessments.forEach(ele => { ele.aois = ele.years = null; });
    postData['geAssessments'] = this.selectedAssessments;
    this.apiService.postData('GetChildGEData', postData, false, true).subscribe((res: any) => {     
        const data = res;
        this.childGridHeaderMap = data.expandCols;
        this.createDynamicCols(this.advGEGridOptions, this.advGEGridColDef, data.groupedData, true);
        this.advGEsRowData = data.groupedData;
        this.advGEsRowDataCopy = JSON.parse(JSON.stringify(data.groupedData));
        this.showGEsToAdvance = true;      
    });
  }

  updateColor(event: any) {
    if (event)
      this.selColor = event.target.value;
    StaticFields.precodeScreenData['selectedColor'] = this.selColor;
    this.showColorSelector = false;
  }

  setScreenData(hasCropChanged: boolean) {
    if (this.settingPageLoadData) {
      if (this.crops.find(ele => ele.Name == StaticFields.precodeScreenData.crop.Name)) {
        this.selectedCrop = StaticFields.precodeScreenData.crop;
        this.selectedLevel = StaticFields.precodeScreenData.level;      
        this.geAssessmentsList = StaticFields.precodeScreenData.geAssessmentsList;
        this.pStageData = StaticFields.precodeScreenData.pStageData;
        this.pStagesList = StaticFields.precodeScreenData.pStagesList;
        if (StaticFields.precodePreference && StaticFields.precodePreference.crop === this.selectedCrop.Name) {
          if (StaticFields.precodePreference.userPreferredGeTraits) {
            this.geAssessmentsList.push(...StaticFields.precodePreference.userPreferredGeTraits.filter(t => this.geAssessmentsList.findIndex(a => a.traitId === t.traitId) === -1));
            this.geAssessmentsList = this.geAssessmentsList.sort((a , b) => a.traitName.localeCompare(b.traitName));
          }
          // if (StaticFields.precodePreference.userPreferredPStages) {
          //   const pStageSettings = JSON.parse(JSON.stringify(StaticFields.precodePreference.userPreferredPStages.filter(t => this.pStagesList.findIndex(a => a.crop === t.crop && a.settingType === t.settingType && a.type === t.type && JSON.stringify(a.name.split(',').sort()) === JSON.stringify(t.name.split(',').sort()) && JSON.stringify(a.year.split(',').sort()) === JSON.stringify(t.year.split(',').sort())) === -1)));
          //   // let i = Math.max(...pStageSettings.map((s: any) => s.id));
          //   // pStageSettings.forEach((p: any) => { i++; p.id = i; });
          //   this.pStagesList.push(...JSON.parse(JSON.stringify(pStageSettings)));
          //   pStageSettings.forEach((ele: any) => {ele.name = ele.name.split(",");ele.year = ele.year.split(",")});
          //   this.pStageData.push(...pStageSettings);
          // }
        }
        this.selectedAssessments = StaticFields.precodeScreenData.selectedAssessmentsList;
        this.selectedPStages = StaticFields.precodeScreenData.selectedPStages;      
        this.favProgramsChecked = StaticFields.precodeScreenData.isFavouriteSelected;
        if (StaticFields.precodeScreenData.headerLegend)
          this.headerLegend = StaticFields.precodeScreenData.headerLegend;
        this.applyHeaderLegend();
        this.getMasterData();    
        this.getMetaData(); 
        const expandBy = StaticFields.precodeScreenData.expandBy.split(',');
        this.setExpandOptions(expandBy);
      } else {
        this.customMessageService.showMessage({severity: 'warn', summary:`Crop ${StaticFields.precodeScreenData.crop.Name} is inactive` , detail: `Session crop ${StaticFields.precodeScreenData.crop.Name} is inactive, can't load session.`});
      }
    } else if(StaticFields.precodePreference && StaticFields.precodePreference.appUserId) {
      if (!hasCropChanged)
        this.selectedCrop = this.crops.find(ele => ele.Name == StaticFields.precodePreference.crop);
      if (this.selectedCrop) {
        this.selectedLevel = this.levels.find(ele => ele.name == StaticFields.precodePreference.level);
        this.selectedYears = StaticFields.precodePreference.years !== "" && StaticFields.precodePreference.years.split(",").length > 0 ? StaticFields.precodePreference.years.split(",") : [];
        this.headerLegend = JSON.parse(StaticFields.precodePreference.headerColorOptions);
        this.applyHeaderLegend();
        if (!hasCropChanged) {
          this.getMasterData();   
          this.getMetaData();
        }
        this.geLineageChecked = StaticFields.precodePreference.geLineage;
        this.popRequestChecked = StaticFields.precodePreference.popRequest;
        this.seedInventoryChecked = StaticFields.precodePreference.seedInventory;
        this.experimentsChecked = StaticFields.precodePreference.experiments;
        this.apexVoteChecked = StaticFields.precodePreference.apexVote;
        this.geAssessmentsList = JSON.parse(JSON.stringify(StaticFields.precodePreference.userPreferredGeTraits));
        this.selectedAssessments = this.geAssessmentsList.filter(ele => ele.selected == true);
        this.pStagesList = JSON.parse(JSON.stringify(StaticFields.precodePreference?.userPreferredPStages ? StaticFields.precodePreference.userPreferredPStages : [] ));   
        this.pStageData = JSON.parse(JSON.stringify(StaticFields.precodePreference?.userPreferredPStages ? StaticFields.precodePreference.userPreferredPStages : [] ));   
        this.pStageData.forEach(ele => {ele.name = ele.name.split(",");ele.year = ele.year.split(",")});
        this.selectedPStages = this.pStagesList.filter(ele => ele.selected == true);
      }
      else {
        this.customMessageService.showMessage({severity: 'warn', summary:`Crop ${StaticFields.precodePreference.crop} is inactive` , detail: `Saved crop ${StaticFields.precodePreference.crop} is inactive, can't load preferences.`});
      }
    }
  }

  applyHeaderLegend(save? : boolean) {
    this.selPrgs = {};
    document.documentElement.style.setProperty('--pop', this.headerLegend.find((ele : any) => ele.type == "POP")?.color);
    document.documentElement.style.setProperty('--ge', this.headerLegend.find((ele : any) => ele.type == "GE")?.color);
    document.documentElement.style.setProperty('--expt', this.headerLegend.find((ele : any) => ele.type == "EXPT")?.color);
    document.documentElement.style.setProperty('--si', this.headerLegend.find((ele : any) => ele.type == "SI")?.color);
    document.documentElement.style.setProperty('--apex', this.headerLegend.find((ele : any) => ele.type == "APEX")?.color);
    document.documentElement.style.setProperty('--trait', this.headerLegend.find((ele : any) => ele.type == "TRAIT")?.color);
    let i = 1;
    this.selectedPStages.filter((ele: any) => ele.settingType === 'PStage' && ele.type === 'Program(s)').map((ps: any) => ps.name).forEach((n: string) => {
      n.split(",").forEach((prg: any) => {
        const prgLCase = prg.toLowerCase();
        const foundPrg = this.headerLegend.find((ele : any) => ele.type.toLowerCase() === `program:${prgLCase}`);
        if (foundPrg) {
          document.documentElement.style.setProperty(`--prg${i}`, foundPrg.color);
          this.selPrgs[`program:${prgLCase}`] = `prg${i}`;
          i++;
        } else if (this.headerLegend.filter((h: any) => h.isProgram).length < 101) {
          this.headerLegend.push({type: `Program:${prgLCase.toUpperCase()}`, color : "#F5F7F7", isProgram: true});
          document.documentElement.style.setProperty(`--prg${i}`, "#F5F7F7");
          this.selPrgs[`program:${prgLCase}`] = `prg${i}`;
          i++;
        }
      });
    });
    this.selectedPStages.filter((ele: any) => ele.settingType === 'PStage' && ele.type === 'Region(s)').map((ps: any) => ps.name).forEach((n: string) => {
      n.split(",").forEach((rgn: any) => {
        const rgnLCase = rgn.toLowerCase();
        const foundRgn = this.headerLegend.find((ele : any) => ele.type.toLowerCase() === `region:${rgnLCase}`);
        if (foundRgn) {
          document.documentElement.style.setProperty(`--prg${i}`, foundRgn.color);
          this.selPrgs[`region:${rgnLCase}`] = `prg${i}`;
          i++;
        } else if (this.headerLegend.filter((h: any) => h.isProgram).length < 101) {
          this.headerLegend.push({type: `Region:${rgnLCase.toUpperCase()}`, color : "#D3D3D3", isProgram: true});
          document.documentElement.style.setProperty(`--prg${i}`, "#D3D3D3");
          this.selPrgs[`region:${rgnLCase}`] = `prg${i}`;
          i++;
        }
      });
    });
    this.selectedPStages.filter((ele: any) => ele.settingType === 'PStage' && ele.type === 'EZ(s)').map((ps: any) => ps.name).forEach((n: string) => {
      n.split(",").forEach((ez: any) => {
        const ezLCase = ez.toLowerCase();
        const foundEZ = this.headerLegend.find((ele : any) => ele.type.toLowerCase() === `ez:${ezLCase}`);
        if (foundEZ) {
          document.documentElement.style.setProperty(`--prg${i}`, foundEZ.color);
          this.selPrgs[`ez:${ezLCase}`] = `prg${i}`;
          i++;
        } else if (this.headerLegend.filter((h: any) => h.isProgram).length < 101) {
          this.headerLegend.push({type: `EZ:${ezLCase.toUpperCase()}`, color : "#D3D3D3", isProgram: true});
          document.documentElement.style.setProperty(`--prg${i}`, "#D3D3D3");
          this.selPrgs[`ez:${ezLCase}`] = `prg${i}`;
          i++;
        }
      });
    });
    if (save) {
      if (!StaticFields.precodePreference) {
        this.customMessageService.showMessage({severity: 'warn', summary: 'Not Found' , detail: `No prefrences found for user, can't save.`});
        return;
      }
      StaticFields.precodePreference.headerColorOptions = JSON.stringify(this.headerLegend);
      StaticFields.precodeScreenData.headerLegend = JSON.parse(StaticFields.precodePreference.headerColorOptions);
      const pref = JSON.parse(JSON.stringify(StaticFields.precodePreference));
      this.apiService.putData('SavePreferences', pref,true ,false,true).subscribe(res => {    
        let params = new HttpParams();
        params = params.append('type', 'PreCode');
        params = params.append('appUserId', StaticFields.appUserId);
        this.apiService.getData('GetPreferences', params, false).subscribe((res: any) => {
          StaticFields.precodePreference = res;      
        });
      });
    } else if (StaticFields.precodeScreenData)
      StaticFields.precodeScreenData.headerLegend = JSON.parse(JSON.stringify(this.headerLegend));      
  }
  
  getBGColorByExpandType(type: string) {
    return this.headerLegend.find((ele : any) => ele.type === type)?.color;
  }

  cancelGridChanges() {
    this.confirmationService.confirm({
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      message: `Are you sure you want to cancel the pending changes?`,     
      accept: () => {
        this.rowData = JSON.parse(JSON.stringify(this.rowDataCopy));
        this.editedData = {};
        if (StaticFields.precodeScreenData)
          StaticFields.precodeScreenData.editedData = this.editedData;
      }
    });
  }

  saveChanges() {
    this.submitData(this.updatedData, this.rowDataCopy);
  }

  saveAdvGEChanges() {
    this.submitData(this.updatedAdvGEData, this.advGEsRowDataCopy);
  }

  submitData(updatedData: any[], rowDataCopy: any[]) {
    const dataToSubmit: number[] = [];
    const gesToDel: any = [];
    updatedData.forEach((d: any) => {
      const existingRow = rowDataCopy.find(g => g.geid === d.geid);
      const program: any = {};
      program.geId = d.geid;
      program.crop = d.crop;
      program.year = 0;
      program.stage = '';
      program.addedBy = '';
      let shouldAdd = false;
      Object.keys(existingRow).forEach(k => {
        if ((k.includes('pstage') || k.includes('MetaData') || k.includes('Tag') || (k.includes('Comments') && !k.includes('seed_Comments'))) && !(k.includes("Region") || k.includes("EZ"))) {
          const parts = k.split('_');
          if (parts.length > 1 && existingRow[k] !== d[k]) {
            if (parts.length === 3){
              program.name = parts[1];
              program.year = parts[2];
              program.stage = d[k] ? d[k] : 'd';
              gesToDel.push(d.geid);
              shouldAdd = true;
            } else if (parts[1] === 'Comments') {
              program.name = parts[0].toUpperCase();
              program.comments = d[k] ? d[k] : 'd';
              shouldAdd = true;
            } else if (parts[1] === 'MetaData') {
              program.name = parts[0].toUpperCase();
              program.metaData = d[k] ? d[k] : 'd';
              shouldAdd = true;
            } else if (parts[1] === 'Tag') {
              program.name = parts[0].toUpperCase();
              program.customMetaData = d[k] ? d[k] : 'd';
              shouldAdd = true;
            }
          }
        }
      });
      if (shouldAdd)
        dataToSubmit.push(program);
    });
    this.apiService.putData("SubmitPreCodeData", dataToSubmit).subscribe((res: any) => {
      updatedData.forEach((d: any) => d.hasChanges = false);
      if (gesToDel.length > 0) {
        const rowsTodel = updatedData.filter(g => gesToDel.includes(g.geid));
        this.rowData = this.rowData.filter(g => !gesToDel.includes(g.geid));
        this.gridApi!.applyTransaction({ remove: rowsTodel })!;
      }
      this.editedData = {};
      this.gridApi.redrawRows();
      if (StaticFields.precodeScreenData)
        StaticFields.precodeScreenData.editedData = this.editedData;
      this.showGEsToAdvance = false;
      this.rowDataCopy = JSON.parse(JSON.stringify(this.rowData));
    });
  }

  onCellValueChanged(item: any, params?: any) {
    const field = params ? params.column.colId : item.colDef.field;
    let val = params ? params.value : item.value;
    
    const existingVal = this.rowDataCopy.find(d => d.id === item.data.id);
    const editableFields = this.gridColDef.filter((col: any) => col.editable).map((col: any) => col.field);
    if (item.source === 'paste' && editableFields.includes(field) && !field.includes('Comments')) {
      if (field.includes('pstage') && !(val === "" || this.stages.map(t => t.toUpperCase()).includes(val.toUpperCase()))) {
        this.undoGridChanges();
        return;
      } else if (field.includes('Tag')) {
        const allTags = this.tagList.map(t => t.toUpperCase());
        const validData: string[] = [];
        val.split(';').forEach((t: string) => {
          const idx = allTags.indexOf(t.toUpperCase());
          if (idx > -1)
            validData.push(this.tagList[idx]);
        });
        if (validData.length === 0) {
          this.undoGridChanges();
          return;
        } else
          item.data[field] = val = validData.join(';');
      } else if (field.includes('MetaData')) {
        let enteredData = val.split(';');
        if (enteredData.length === 1)
          enteredData = val.split(',');
        const allMeta= this.metaDataList.map(t => t.toUpperCase());
        const validData: string[] = [];
        enteredData.forEach((t: string) => {
          const idx = allMeta.indexOf(t.toUpperCase());
          if (idx > -1)
            validData.push(this.metaDataList[idx]);
        });
        if (validData.length === 0) {
          this.undoGridChanges();
          return;
        } else
          item.data[field] = val = validData.join(',');
      }
    }
    
    item.data.hasChanges = false;
    editableFields.forEach(f => {
      if (item.data[f] !== existingVal[f])
        item.data.hasChanges = true;
    });
    
    this.editedData[`${item.data.id}:${field}`] = existingVal[field] !== val;
    if (item.node)
      this.gridApi.redrawRows({ rowNodes: [item.node] });
  }

  onAdvGECellValueChanged(item: any,params?: any) {
    const existingVal = this.advGEsRowDataCopy.find(d => d.id === item.data.id);
    const editableFields = this.advGEGridColDef.filter((col: any) => col.editable).map((col: any) => col.field);
    item.data.hasChanges = false;
    editableFields.forEach(f => {
      if (item.data[f] !== existingVal[f])
        item.data.hasChanges = true;
    });
    // if (item.data.hasChanges) {
    //   const colId = params ? params.column.colId : item.column.colId;
    //   const existingVal = this.advGEsRowDataCopy.find(d => d.id === item.data.id);
    //   item.data.hasChanges = existingVal[colId] !== item.newValue;
    // } else
    //   item.data.hasChanges = true;
  }
  
  onExpandOptionChanged($event: CheckboxChangeEvent, expandType: string) {
    StaticFields.precodeScreenData.expandBy = this.getExpandOptions();
    if (this.headerMap) {
      if ($event.checked) {
        const hasUserSavedPref = this.userGridPreference?.preference ? true : false;
        const cols = hasUserSavedPref ? JSON.parse(this.userGridPreference.preference) : this.gridColDef;
        this.applySavedColState(cols, false);
      } else {
        const cols = Object.keys(this.headerMap).filter(key => expandType === 'apex' ? this.headerMap[key].includes('apex') : this.headerMap[key] === expandType);
        this.gridApi.setColumnsVisible(cols, $event.checked);
      }
    }
  }

  closeAdvGEGrid() {
    if (this.updatedAdvGEData.length > 0) {
      this.confirmationService.confirm({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: `Are you sure you want to cancel the pending changes?`,     
        accept: () => {
          this.showGEsToAdvance = false;
        }
      });
    } else
    this.showGEsToAdvance = false;
  }

  onSelectionChanged($event: SelectionChangedEvent<any,any>) {
    if ($event.source === "uiSelectAllFiltered" || $event.source === "api") {
      StaticFields.precodeScreenData.selNodes = [];
      const selNodes = this.gridApi.getSelectedNodes();
      if (selNodes && selNodes.length > 0) {
        selNodes.forEach((n: any) => StaticFields.precodeScreenData.selNodes.push(n.data.id));
      }
    } else if ($event.source === "checkboxSelected") {
      const lastCellCliked: CellPosition = this.gridApi.getFocusedCell();
      let node = this.gridApi.getDisplayedRowAtIndex(lastCellCliked.rowIndex);
      let nodeIdx = -1;

      if (StaticFields.precodeScreenData.selNodes && StaticFields.precodeScreenData.selNodes.length > 0) {
        nodeIdx = StaticFields.precodeScreenData.selNodes.findIndex((id: any) => id === node.data.id);
        if (!node.selected && nodeIdx > -1) {
          StaticFields.precodeScreenData.selNodes.splice(nodeIdx, 1);
          return;
        }
      } else 
        StaticFields.precodeScreenData.selNodes = [];
      if (node.selected && nodeIdx === -1)
        StaticFields.precodeScreenData.selNodes.push(node.data.id);
    }
  }

  onFilerChanged($event: FilterChangedEvent<any,any>) {
    this.customStatusBar.updateFilters(this.gridApi, true, this);
  }

  onAdvGEFilerChanged($event: FilterChangedEvent<any,any>) {
    this.advGridFilterBar.updateFilters(this.advGEGridApi, false, this);
  }

  onGridPreDestroyed($event: GridPreDestroyedEvent<any,any>) {
    if ($event?.api && StaticFields.precodeScreenData)
      StaticFields.precodeScreenData.colState = $event.api.getColumnState();
  }

  onCellKeyDown($event: import("ag-grid-community").CellKeyDownEvent<any,any>|import("ag-grid-community").FullWidthCellKeyDownEvent<any,any>) {
    let e = $event.event as unknown as KeyboardEvent;
    if (e.key === 'f' && e.ctrlKey) {
      this.showFindReplace = true;
    }    
  }

  loadSession() {
    this.showSessions = this.showSearch = false;
    this.selSession = this.sessionGridApi.getSelectedRows()[0];
    this.sessionName = this.selSession.name;
    this.existingGridColors.splice(0);
    this.rowData.splice(0);
    this.editedData = {};
    this.loader.setMessage('Loading...');   
    this.getUserGridPreferences(this.sessionName, true, false);
  }

  openColorSelector() {
    this.showColorSelector = true;
    setTimeout(() => {
      let listbox: string = '';
      const colorLb = document.getElementById("lbMainColor") as HTMLElement;
      this.existingGridColors.forEach((c: string) => {
        listbox +='<option style="height: 30px; background-color: ' + c + ';" value="' + c + '"></option>';
      });
      listbox +='<option style="height: 30px; font-size: 17px; padding: 5px;" value="No Fill">No Fill</option>';
      colorLb.innerHTML = listbox;
    }, 10);
  }

  getAdvGEContextMenuItems(params: any) {
    let result = [
        {
          name: 'Fill Up',
          disabled: !(!isNaN(params.node.id) && Number(params.node.id) > Number(params.node.parent.childrenAfterGroup[0].id) && params.column.colId.includes('stage')),
          action: function () { params.context.fill(params, "up", true); },
        },
        {
          name: 'Fill Down',
          disabled: !(!isNaN(params.node.id) && Number(params.node.id) < Number(params.node.parent.childrenAfterGroup[params.node.parent.childrenAfterGroup.length - 1].id) && params.column.colId.includes('stage')),
          action: function () { params.context.fill(params, "down", true); }
        },
        // {
        //   name: 'Fill Selected',
        //   disabled: !(params.api.getSelectedRows().length > 1 && params.column.colId.includes('stage')),
        //   action: function () { params.context.fill(params, "selected", true); }
        // },
        'separator',
        'copy',
        'copyWithHeaders',
        {
          name: 'Export',
          icon:'<i class="fa fa-upload"></i>',
          action: function () { params.context.exportAdvGEGrid(false); }
        },
        {
          name: 'Export Selected rows',
          icon:'<i class="fa fa-upload"></i>',
          action: function () { params.context.exportAdvGEGrid(true); }
        }
        
      ]
    return result;
  }

  getContextMenuItems(params: any) {
    let result = [
        {
          name: 'View History',
          disabled: !( params.api.getSelectedRows().length == 1),
          action: function () { params.context.getHistory(); }
        },
        {
          name: 'Add Row(S)',
          action: function () { params.context.showAddRowDialog(); }
        },{
          name: 'Remove Row',
          disabled: !(params.api.getSelectedRows().length > 0),
          action: function () { params.context.removeRows(params,"row"); }
        },
        {
          name: 'Remove Selected',
          disabled: !(params.api.getSelectedRows().length > 0),
          action: function () { params.context.removeRows(params,"selected"); }
        },
        {
          name: 'Remove Value',
          disabled: !(params.value && params.column.colDef.editable),
          action: function () { params.context.removeValue(params); }
        },
        {
          name: 'Copy/Move Rows to Session',
          disabled: !(params.api.getSelectedRows().length > 0),
          action: function () { params.context.openCopyRowsModal(); }
        },
        {
          name: 'Bulk Edit',
          disabled: !(params.api.getSelectedRows().length > 1 && params.api.getAllDisplayedColumns().map((c: any) => c.colId).findIndex((c: string) => c.includes('MetaData')) > -1),
          action: function () { params.context.editMultipleRows(); }
        },
        'separator',
        {
          name: 'Fill Up',
          disabled: !(!isNaN(params.node.rowIndex) && params.value && Number(params.node.rowIndex) > 0 && ((params.column.colId.includes('_Comments') && !params.column.colId.includes('seed_Comments')) || params.column.colId.includes('stage') || params.column.colId.includes('MetaData') || params.column.colId.includes('Tag'))),
          action: function () { params.context.fill(params, "up", false); },
        },
        {
          name: 'Fill Down',
          disabled: !(!isNaN(params.node.id) && params.value && Number(params.node.rowIndex) <  Number(params.node.parent.allChildrenCount) - 2 && (params.column.colId.includes('_Comments') && !params.column.colId.includes('seed_Comments')) || params.column.colId.includes('stage') || params.column.colId.includes('MetaData') || params.column.colId.includes('Tag')),
          action: function () { params.context.fill(params, "down", false); }
        },
        // {
        //   name: 'Fill Selected',
        //   disabled: !((params.api.getSelectedRows().length > 1 || Math.abs(params.api.getCellRanges()[0].startRow.rowIndex - params.api.getCellRanges()[0].endRow.rowIndex) > 1) && ((params.column.colId.includes('omments') && !params.column.colId.includes('seed_Comments')) || params.column.colId.includes('stage') || params.column.colId.includes('MetaData') || params.column.colId.includes('Tag'))),
        //   action: function () { params.context.fill(params, "selected", false); }
        // },
        'separator',
        {
          name: 'Code',
          disabled: !(params.api.getSelectedRows().length > 0) || params.context.selectedPStages.filter((ele: any) => ele.settingType === 'PStage' && ele.type === 'Program(s)').length === 0,
          action: function () { params.context.navigateToCode(); }
        },
        {
          name: 'Append APEX Session',
          disabled: !(params.api.getSelectedRows().length > 0),
          action: function () { params.context.getAPEXSessionsForUser(); }
        },
        'separator',
        {
          name: 'Report - Line Graph',
          disabled: !(params.api.getSelectedRows().length > 0),
          action: function () { params.context.displayReport('linegraph'); }
        },
        {
          name: 'Report - Experiment Detail',
          disabled: !(params.api.getSelectedRows().length > 0),
          action: function () { params.context.displayReport('experiment'); }
        },
        {
          name: 'Report - Pop Request',
          disabled: !(params.api.getSelectedRows().length > 0 && 'req_Id' in params.api.getSelectedRows()[0]),
          action: function () { params.context.confirmPopGEs(); }
        },
        {
          name: 'Report - PStage Detail',
          disabled: !(params.api.getSelectedRows().length > 0),
          action: function () { params.context.displayReport('pstage'); }
        },
        {
          name: 'Report - Nursery Selection',
          disabled: !(params.api.getSelectedRows().length > 0 && 'expt_Name' in params.api.getSelectedRows()[0]),
          action: function () { params.context.openNurseryDialog(); }
        },
        // {
        //   name: 'Report - Usage',
        //   disabled: !(params.api.getSelectedRows().length > 0 && params.api.getAllDisplayedColumns().map((c: any) => c.colId).findIndex((c: string) => c.includes('MetaData')) > -1),
        //   action: function () { params.context.openUsageDialog(); }
        // },
        'separator',
        {
          name: 'Set Row Color',
          action: function () { params.context.setColor(params, 'row'); }
        },
        {
          name: 'Set Column Color',
          action: function () { params.context.setColor(params, 'col'); }
        },
        {
          name: 'Set Cell Color',
          action: function () { params.context.setColor(params, 'cell'); }
        },
        'separator',
        'copy',
        'copyWithHeaders',
        {
          name: 'Export',
          icon:'<i class="fa fa-upload"></i>',
          action: function () { params.context.export(false); }
        },
        {
          name: 'Export Selected rows',
          icon:'<i class="fa fa-upload"></i>',
          action: function () { params.context.export(true); }
        }
        
      ]
    return result;
  }

  toggleFavorites(event: any) {
    if (!StaticFields.precodePreference) {
      this.customMessageService.showMessage({severity: 'warn', summary: 'Not Found' , detail: `No prefrences found for user.`});
      return;
    }
    if (event.checked) {
      const favorites = StaticFields.precodePreference.favouritePrograms.split(",");     
      if (favorites.length > 0)
        this.inclusions = this.inclusionsCopy.filter((p: any) => favorites.indexOf(p.code) !== -1);
      else
        this.inclusions = [];
      this.selectedInclusions = [];
    } else {
      this.inclusions = this.inclusionsCopy;
      this.selectedInclusions = this.inclusions.filter((p: any) => StaticFields.precodePreference.include.split(",").indexOf(p.code) !== -1);
    }
  }

  export(selected?: boolean) {
    this.exportGrid(selected, this.gridApi);
  }

  exportAdvGEGrid(selected: boolean) {
    this.exportGrid(selected, this.advGEGridApi);
  }

  exportGrid(selected: boolean, gridApi: any) {
    let id = '';
    const excelStyles: ExcelStyle[] = [];
    this.headerLegend.forEach((l: any) => {
      const type = l.type.toLowerCase();
      const prgNo = type.includes(':apex') ? this.selPrgs[type.replace(':apex', '')] : this.selPrgs[type];
      if (prgNo) 
        id = `${prgNo}Header`;
      else 
        id = `${type}Header`;
      const excelHeader: ExcelStyle = { id: id };
      excelHeader.interior = { color: l.color, pattern: 'Solid' };
      excelStyles.push(excelHeader);
    });
    gridApi.setGridOption('excelStyles', excelStyles);
    this.commonService.downloadExcelFile(gridApi, selected);
  }

  editMultipleRows() {
    if (!StaticFields.userClaim.isPCMSuperUser) {
      // this.bulkEditPrgs = this.bulkEditPrgs.filter(p => StaticFields.userPrograms.includes(p));
      this.bulkEditPrgs = this.bulkEditPrgs.filter(p => StaticFields.userPrograms.filter(p => p.cropName == this.selectedCrop.Name).map(p => p.code).includes(p));
      if (this.bulkEditPrgs.length === 0) {
        this.customMessageService.showMessage({severity: 'warn', summary: 'No Access' , detail: "You don't have access to edit these programs."});
        return;
      }
    }
    this.bulkPStage = this.bulkComments = '';
    this.bulkYear = null;
    this.bulkTags.splice(0);
    this.bulkMetaData.splice(0);
    this.appendComments = this.appendMetadata = this.appendTags = true;
    this.editPStageChecked = this.editCusMetadataChecked = this.editCommentsChecked = this.editMetadataChecked = false;
    if (this.bulkEditPrgs.length > 0)
      this.selBulkEditPrg = this.bulkEditPrgs[0];
    this.showBulkEditDialog = true;
  }

  removeValue(params : any) {
    params.value = params.node.data[params.column.colDef.field] = "";
    this.onCellValueChanged(params.node, params);
    this.gridApi.redrawRows({ rowNodes: [params.node] });
  }

  getHistory() {
    const selectedRow = this.gridApi.getSelectedRows();    
    let params = new HttpParams();
    params = params.append("crop", selectedRow[0].crop);
    params = params.append("geId", selectedRow[0].geid);
    this.apiService.getData('GetPreCodesHistory', params).subscribe((res: any) => {   
    if (res.length > 0) {
      this.historyData = res;
      this.showHistoryDialog = true;
    }
    else {
      this.customMessageService.showMessage({'severity': 'warn', summary: 'No History Found', detail: 'No History Found.'});    
      this.showHistoryDialog = false;
    }
    });
  }

  removeRows(params: any, type: string) {
    if (type === "row"){
      const index = this.rowData.findIndex((ele : any) => ele.id == params.node.data.id);
      this.rowData.splice(index,1);
      this.gridApi!.applyTransaction({ remove: [params.node.data] })!;
    } else {
      const selectedNodes = this.gridApi.getSelectedRows();
      this.gridApi!.applyTransaction({ remove: selectedNodes })!;
      this.rowData = this.rowData.filter((ele : any) => {
        return selectedNodes.indexOf(ele) === -1;
      })
    }
    StaticFields.precodeScreenData.data = this.rowData;
  }

  selectRows(shallSelect: boolean) {
    const nodesToUpdate: any = [];
    const selCells = this.gridApi.getCellRanges();
    selCells.forEach((c: any) => {
      this.gridApi.forEachNodeAfterFilterAndSort((node: any) => { 
        if (node.rowIndex >= c.startRow.rowIndex && node.rowIndex <= c.endRow.rowIndex)
          nodesToUpdate.push(node);
      });
    });
    this.gridApi.setNodesSelected({ nodes: nodesToUpdate, newValue: shallSelect });
  }

  confirmPopGEs() {
    this.confirmationService.confirm({
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      message: `Do you want to limit the report to selected GEs only?`,     
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      acceptIcon: "none",
      rejectIcon: "none",
      accept: () => {
        this.selGEsOnly = true;
        this.displayReport('poprequest');
      },
      reject: () => {
        this.selGEsOnly = false;
        this.displayReport('poprequest');
      }
    });
  }

  displayReport(type: string) {
    this.showNurserySelection = this.showUsageModal = false;
    const selectedNodes = this.gridApi.getSelectedRows();
    const selGeIds = selectedNodes.map((ele: any) => ele.geid).join();
    const ids = type == 'poprequest' ? selectedNodes.map((ele: any) => ele.req_Id).join() : type === 'nursery' ? this.selectedExpts.map((e: any) => e.exptId).join() : selGeIds;
    this.ref = this.dialogService.open(CommonreportmodalComponent, {
      data : {
        type: type,
        url: type == 'experiment' ? 'GetExperimentDataByGEs' : type == 'pstage' ? 'GetPStageDataByGEs' : type == 'poprequest' ? 'GetDHRequestDetails' : type === 'nursery' ? 'GetNurserySelections' : type === 'usage' ? 'GetUsageReport' : 'GetLineGraph',  
        ids : ids,
        crop : this.selectedCrop,
        program: this.selectedPrg?.code,
        usageYears: this.selUsageYears,
        usagePrograms: this.selUsagePrograms,
        selGeIds: (type === 'nursery' || type === 'poprequest') && this.selGEsOnly ? selGeIds : null,
        report : true
      },
      header: type == 'experiment' ? 'Experiment Detail Report' : type ==  'pstage' ? 'PStage Detail Report':   type ==  'poprequest' ?  'Pop Request Detail Report'  : type === 'nursery' ? 'Nursery Selections Report' : type === 'usage' ? 'Usage Report' : 'Linegraph Detail Report',
      width: '95%',
      height: '90%',
      styleClass: 'reportModal',
      appendTo: 'body',
      modal: true,
      closable : true,
    });
    this.selGEsOnly = true;
  }

  fill(params: any, fillType: string, isAdvGE: boolean) {
    if (fillType === "down" || fillType === "up") {
      // const children = params.node.parent.childrenAfterGroup;
      let idx = params.node.rowIndex;
      params.api.forEachNodeAfterFilterAndSort((rowNode: any) => {
        if (fillType === "up" ? idx > rowNode.childIndex : idx < rowNode.childIndex) {
          //const existingVal = this.rowDataCopy.find(r => r.id === rowNode.data.id)[params.column.colId];
          if (rowNode.data && ((params.column.colId.includes('stage') && this.stages.includes(params.value)) || params.column.colId.includes('omments') || params.column.colId.includes('MetaData') || params.column.colId.includes('Tag') || !params.value)) {
            rowNode.data[params.column.colId] = params.value;
            isAdvGE ? this.onAdvGECellValueChanged(rowNode,params) : this.onCellValueChanged(rowNode,params);
          }
        }
      });
    } else if (fillType === "selected") {
      params.api.getSelectedRows();
      const selCells = params.api.getCellRanges()[0];
      const startIdx = selCells.startRow.rowIndex;
      let endIdx = selCells.endRow.rowIndex;
      let idx = startIdx;
      if (endIdx < startIdx) {
        idx = endIdx;
        endIdx = startIdx;
      }
      if (idx < endIdx) {
        while (idx <= endIdx) {
          var row = params.api.getDisplayedRowAtIndex(idx);
          if (row.data && ((params.column.colId.includes('stage') && this.stages.includes(params.value)) || params.column.colId.includes('omments') || params.column.colId.includes('MetaData') || params.column.colId.includes('Tag') || !params.value)) {
            row.data[params.column.colId] = params.value;
            isAdvGE ? this.onAdvGECellValueChanged(row, params) : this.onCellValueChanged(row, params);
          }
          idx++;
        }
      } else {
        params.api.getSelectedNodes().forEach((rowNode: any) => {
          if (rowNode.data && ((params.column.colId.includes('stage') && this.stages.includes(params.value)) || params.column.colId.includes('omments') || params.column.colId.includes('MetaData') || params.column.colId.includes('Tag') || !params.value)) {
            rowNode.data[params.column.colId] = params.value;
            isAdvGE ? this.onAdvGECellValueChanged(rowNode,params) : this.onCellValueChanged(rowNode,params);
          }
        });
      }
    }
    params.api.refreshCells(params);
  }

  setColor(params: any, type: string) {
    const selRows : any[] = [];
    const selCells = params.api.getCellRanges();
    let uniqueCols: string[] = [];
    const grpColCount = params.api.getRowGroupColumns().length;
    let node = params.node.parent;
    for (let i = 0; i < grpColCount; i++) {
      node = node.parent;
    }
    if (type === 'col') {
      const cols = selCells.map((c:any) => c.columns).flatMap((cols: any) => cols).map((col: any) => col.colId);
      uniqueCols = cols.filter((value: string, index: number, array: string[]) => array.indexOf(value) === index);
      node.allLeafChildren.forEach((rowNode: any) => {
        selRows.push(rowNode);
        uniqueCols.forEach((colId: string) => {
          rowNode.data[`${colId}_cellColor`] = this.selColor;
        });
      });
    } else {
      selCells.forEach((r : any) => {
        const startIdx = r.startRow.rowIndex;
        let endIdx = r.endRow.rowIndex;
        let idx = startIdx;
        if (endIdx < startIdx) {
          idx = endIdx;
          endIdx = startIdx;
        }
        while (idx <= endIdx) {
          var row = params.api.getDisplayedRowAtIndex(idx);
          if (type === 'row') {
            Object.getOwnPropertyNames(row.data).forEach((col) => {
              row.data[`${col}_cellColor`] = this.selColor;
              if (!uniqueCols.includes(col))
                uniqueCols.push(col);
            });
          } else {
            r.columns.forEach((c : any) => {
              row.data[`${c.colId}_cellColor`] = this.selColor;
              if (!uniqueCols.includes(c.colId))
                uniqueCols.push(c.colId);
            });
          }
          selRows.push(row);
          idx++
        }
      });
    }
    const rowData = node.allLeafChildren.map((d: any) => d.data);
    uniqueCols.forEach(col => {
      params.api.getColumnFilterInstance(col).then((filter: any) => {
        if (filter) {
          const cusFilterLb = filter.filters[0].eFilterlb ? filter.filters[0].eFilterlb : filter.filters[1].eFilterlb;
          let listbox: string = '';
          const colName = `${col}_cellColor`;
          const dataWithColor = rowData.filter((o: any) => o && o[colName]);
          dataWithColor.map((d: any) => d[colName]).filter((value: string, index: number, array: string[]) => array.indexOf(value) === index).forEach((c: string) => {
              listbox +='<option style="background-color: ' + c + ';" value="' + c + '"></option>';
          });
          listbox +='<option value="No Fill">No Fill</option>';
          cusFilterLb.innerHTML = listbox;
        }
      });
    });
    params.api.redrawRows({ rowNodes: selRows });
  }
  
  //Find text in ag-grid
  find(clearFoundDataWhenDone: boolean) {
    let found = false;
    let rowNodes: any = [];
    let focusedCell = this.gridApi.getFocusedCell();
    if (focusedCell || this.lastFoundCell) {
      const rowIdx = this.lastFoundCell ? this.lastFoundCell.rowIndex : focusedCell.rowIndex;
      const field = this.lastFoundCell ? this.lastFoundCell.field : focusedCell.column.colId;
      let lastFoundObj: any;
      if (this.foundCell.length > 0) {
        lastFoundObj = this.foundCell[this.foundCell.length - 1];
        if (!(lastFoundObj.rowIndex == rowIdx && lastFoundObj.field == field)) {
          this.foundCell = [];
          this.foundIndex = focusedCell.rowIndex;
        }
      }
    }
    this.gridApi.forEachNode((node: any) => {
      rowNodes.push(node);
    });
    for (let i=this.foundIndex; i < rowNodes.length ; i++) {
      let node = rowNodes[i];
      var rowObj = node.data;
      found = false;
      for (var key in rowObj) {
        if (this.matchWordChecked && rowObj[key] && (this.matchCaseChecked ? rowObj[key].toString() === this.findText : rowObj[key].toString().toUpperCase() === this.findText.toUpperCase()) 
            && !this.foundCell.find(c => c.field === key && c.rowIndex === node.rowIndex)) {
          found = true;
          this.foundCell.push({ 'field': key, 'rowIndex': node.rowIndex});
          break;
        } else if (!this.matchWordChecked && rowObj[key] && (this.matchCaseChecked ? rowObj[key].toString().includes(this.findText) : rowObj[key].toString().toUpperCase().includes(this.findText.toUpperCase())) 
            && !this.foundCell.find(c => c.field === key && c.rowIndex === node.rowIndex)) {
          found = true;
          this.foundCell.push({ 'field': key, 'rowIndex': node.rowIndex});
          break;
        }
      }
      if (found) {
        break;
      }
    }
    if (found) {
      this.lastFoundCell = this.foundCell[this.foundCell.length-1];
      if (clearFoundDataWhenDone) {
        this.gridApi.ensureIndexVisible(this.lastFoundCell.rowIndex, 'middle');
        this.gridApi.ensureColumnVisible(this.lastFoundCell.field);
        this.gridApi.setFocusedCell(this.lastFoundCell.rowIndex, this.lastFoundCell.field);
      }
      this.found = true;
    } else {
      if (this.foundCell.length === 0)
        this.customMessageService.showMessage({'severity': 'warn', summary: 'Not Found', detail: 'No match found' });
      else if (clearFoundDataWhenDone)
        this.customMessageService.showMessage({'severity': 'info', summary: 'No more matches', detail: 'Reached end of Grid. Click find to search again.' });
      this.foundIndex = 0;
      if (clearFoundDataWhenDone)
        this.foundCell = [];
      this.found = false;
      this.lastFoundCell = null;
    }
  }
  
  //Replace text in ag-grid
  replace(isReplaceAll: boolean) {
    if (this.found || isReplaceAll) {
      let focusedCell: any;
      var cell: any;
      let rowNodes: any[] = [];
      focusedCell = this.gridApi.getFocusedCell();
      if (focusedCell) {
        cell = { rowIndex: focusedCell.rowIndex, field: focusedCell.column.colId };
      } else {
        cell = this.foundCell[this.foundCell.length - 1];
      }
      this.gridApi.forEachNode((node: any) => {
        rowNodes.push(node);
      });
      var rowNode: any;
      var newCellValue: any = "";
      if (isReplaceAll) {
        this.foundCell = [];
        this.found = true;
        while (this.found) {
          this.find(false);
        }
        let allfoundCell = this.foundCell;
        let updatedCnt = 0;
        for (var i = 0; i < allfoundCell.length; i++) {
          cell = allfoundCell[i];
          const foundCol = this.gridApi.getColumnDefs().find((c: any) => c.field === cell.field);
          rowNode = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
          const val = this.gridApi.getValue(cell.field, rowNode)
          const currentCellValue = val ? val.toString() : '';
          let splitChar = ',';
          let arrList = this.metaDataList;
          if (cell.field.includes("Tag")) {
            splitChar = ';';
            arrList = this.tagList;
          } else if (cell.field.includes("pstage"))
            arrList = this.stages;
          const vals = currentCellValue.split(splitChar);
          const findTextValid = cell.field.includes("Comments") ? (this.matchCaseChecked ? currentCellValue.includes(this.findText) : currentCellValue.toUpperCase().includes(this.findText.toUpperCase())) : (this.matchCaseChecked ? vals.includes(this.findText) : vals.findIndex((v: string) => v.toUpperCase() === this.findText.toUpperCase()) > -1);
          const replaceTextValid = cell.field.includes("Comments") || arrList.includes(this.replaceText) || this.replaceText === "";
          if (rowNode && foundCol && foundCol.editable &&
            (cell.field.includes("Comments") || ((cell.field.includes("pstage") || cell.field.includes("MetaData") || cell.field.includes("Tag"))
            && findTextValid && replaceTextValid))) {
            if (this.matchCaseChecked)
              newCellValue = currentCellValue.replace(this.findText, this.replaceText);
            else {
              let pattern = new RegExp(this.findText, 'gi');
              newCellValue = currentCellValue.replace(pattern, this.replaceText);
            }
            if (typeof rowNode.data[cell.field] === 'number' && Number(newCellValue))
              newCellValue = Number(newCellValue);
            rowNode.setDataValue(cell.field, newCellValue);
            updatedCnt++;
          }
        }
        this.foundCell = [];
        this.found = false;
        if (allfoundCell.length > 0)
          this.customMessageService.showMessage({'severity': 'info', summary: 'Replaced', detail: `Replaced ${updatedCnt} matches` });
      } else {
        rowNode = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex);
        const currentCellValue = this.gridApi.getValue(cell.field, rowNode).toString();
        let splitChar = ',';
        let arrList = this.metaDataList;
        if (cell.field.includes("Tag")) {
          splitChar = ';';
          arrList = this.tagList;
        } else if (cell.field.includes("pstage"))
          arrList = this.stages;
        const vals = currentCellValue.split(splitChar);
        const findTextValid = cell.field.includes("Comments") ? (this.matchCaseChecked ? currentCellValue.includes(this.findText) : currentCellValue.toUpperCase().includes(this.findText.toUpperCase())) : (this.matchCaseChecked ? vals.includes(this.findText) : vals.findIndex((v: string) => v.toUpperCase() === this.findText.toUpperCase()) > -1);
        const replaceTextValid = cell.field.includes("Comments") || arrList.includes(this.replaceText) || this.replaceText === "";
        if (this.gridApi.getColumnDefs().find((c: any) => c.field === cell.field).editable &&
            (cell.field.includes("Comments") || ((cell.field.includes("pstage") || cell.field.includes("MetaData") || cell.field.includes("Tag"))
            && findTextValid && replaceTextValid))) {
          if (this.matchCaseChecked)
            newCellValue = currentCellValue.replace(this.findText, this.replaceText);
          else {
            let pattern = new RegExp(this.findText, 'gi');
            newCellValue = currentCellValue.replace(pattern, this.replaceText);
          }

          if (newCellValue != rowNode.data[cell.field].toString()) {
            if (typeof rowNode.data[cell.field] === 'number' && Number(newCellValue))
              newCellValue = Number(newCellValue);
            rowNode.setDataValue(cell.field, newCellValue);
          }
        }
        this.find(true);
      }
    }
  }

  addGeAssessments() {
    this.ref = this.dialogService.open(GeassessmentmodalComponent, {
      data : {crops : this.crops, selectedCrop :this.selectedCrop, selectedAssessmentsList :this.geAssessmentsList, session: this.sessionName },
      header: 'Search Germplasm Assessments',
      width: '95%',
      height: '90vh',
      styleClass: 'geModal',
      appendTo: 'body',
      closable : false
    });

    this.ref.onClose.subscribe((result : any) => {
      if (result) {
        const unselectedTraits = this.geAssessmentsList.filter((ge: any) => this.selectedAssessments.findIndex((sa: any) => sa.traitId === ge.traitId) === -1);
        this.showGeTraitGrid = false;
        const newAssessmentMembers = result.assessmentMembers.map((member : any) => {
          const { description: traitDescription, ...rest } = member;
          return { traitDescription, ...rest }
        });
        // newAssessmentMembers.forEach((ele : any) => ele?.traitId == this.geAssessmentsList.find((e: any) => e?.traitId == ele?.traitId)?.traitId ? ele.selected = this.geAssessmentsList.find((e: any) => e.traitId == ele.traitId).selected : ele.selected =  false);
        // this.geAssessmentsList = [...newAssessmentMembers];
        // this.geAssessmentsList = this.geAssessmentsList.filter((value, index, self) =>
        //   index === self.findIndex((t) => (
        //     t.traitId === value.traitId
        //   ))
        // ); 
        newAssessmentMembers.filter((na: any) => unselectedTraits.findIndex((usa: any) => usa.traitId === na.traitId) === -1).forEach((ele : any) => ele.selected = true);
        this.geAssessmentsList = [...newAssessmentMembers];
        this.selectedAssessments = this.geAssessmentsList.filter(m => m.selected); 
        setTimeout(() => {
          this.showGeTraitGrid = true;
        }, 10);                      
      }
    });
  }

  saveBulkEdit() {
    const allCols = this.gridApi.getAllDisplayedColumns().map((c: any) => c.colId);
    const pstageCol = allCols.find((c: any) => c.toUpperCase() === `PSTAGE_${this.selBulkEditPrg}_${this.bulkYear}`);
    const commentCol = allCols.find((c: any) => c.toUpperCase().includes(this.selBulkEditPrg) && c.includes('_Comments'));
    const metadataCol = allCols.find((c: any) => c.toUpperCase().includes(this.selBulkEditPrg) && c.includes('_MetaData'));
    const tagCol = allCols.find((c: any) => c.toUpperCase().includes(this.selBulkEditPrg) && c.includes('_Tag'));
    const selRows = this.gridApi.getSelectedRows();
    selRows.forEach((rowNode: any) => {
      const existingVal = this.rowDataCopy.find(d => d.id === rowNode.id);
      rowNode.hasChanges = true;
      if (this.editPStageChecked && pstageCol) {
        rowNode[pstageCol] = this.bulkPStage;
        this.editedData[`${rowNode.id}:${pstageCol}`] = existingVal[pstageCol] !== rowNode[pstageCol];
      } 
      if (this.editCommentsChecked) {
        rowNode[commentCol] = this.bulkComments === '' || this.bulkComments.toUpperCase() === 'D' ? '' : this.appendComments && rowNode[commentCol] ? rowNode[commentCol] + ';' + this.bulkComments: this.bulkComments;
        this.editedData[`${rowNode.id}:${commentCol}`] = existingVal[commentCol] !== rowNode[commentCol];
      }
      if (this.editCusMetadataChecked) {
        rowNode[tagCol] = this.bulkTags.length === 0 ? '' : this.appendTags && rowNode[tagCol] ? rowNode[tagCol] + ';' + this.bulkTags.join(';') : this.bulkTags.join(';');
        this.editedData[`${rowNode.id}:${tagCol}`] = existingVal[tagCol] !== rowNode[tagCol];
      } 
      if (this.editMetadataChecked) {
        rowNode[metadataCol] = this.bulkMetaData.length === 0 ? '' : this.appendMetadata && rowNode[metadataCol] ? rowNode[metadataCol] + ',' + this.bulkMetaData.join() : this.bulkMetaData.join();
        this.editedData[`${rowNode.id}:${metadataCol}`] = existingVal[metadataCol] !== rowNode[metadataCol];
      }
    });
    this.gridApi.refreshCells(selRows);
    this.showBulkEditDialog = false;
  }

  allowPStageEdit(params: any) {
    return this.sessionName && !this.newPStageIds.includes(params.data.id) ? false : true;
  }

  onRowClick(event : any, type: string) {
    if (this.sessionName && (type === 'pstage' && StaticFields.precodeScreenData.selectedPStages.findIndex((s: any) => s.id === event.id) > -1) 
    || (type === 'geTraits' && StaticFields.precodeScreenData.selectedAssessmentsList.findIndex((s: any) => s.traitId === event.traitId) > -1)) {
      if (type === 'pstage') {
        StaticFields.precodeScreenData.selectedPStages.forEach((item: any) => {
          if (this.selectedPStages.findIndex((s: any) => s.id === item.id) === -1)
            this.selectedPStages.push(item);
        });
        const data = this.selectedPStages.splice(0);
        this.selectedPStages = [...data];
      } else {
        StaticFields.precodeScreenData.selectedAssessmentsList.forEach((item: any) => {
          if (this.selectedAssessments.findIndex((s: any) => s.traitId === item.traitId) === -1)
            this.selectedAssessments.push(item);
        });
        const data = this.selectedAssessments.splice(0);
        this.selectedAssessments = [...data];
      }
    } else 
      event['selected'] = !event['selected'];
  }

  getToolTip(event : any, type: string) {
    if (this.sessionName && (type === 'pstage' && StaticFields.precodeScreenData?.selectedPStages && StaticFields.precodeScreenData.selectedPStages.findIndex((s: any) => s.id === event.id) > -1) 
    || (type === 'geTraits' && StaticFields.precodeScreenData?.selectedAssessmentsList && StaticFields.precodeScreenData.selectedAssessmentsList.findIndex((s: any) => s.traitId === event.traitId) > -1))
      return "Can't remove values for a session.";
    return "";
  }

  undoGridChanges() {
    this.gridApi.undoCellEditing();
  }

  redoGridChanges() {
    this.gridApi.redoCellEditing();
  }

  showPStageDialog() {
    this.showPStageModal = true;
    this.pStageDataCopy = JSON.parse(JSON.stringify(this.pStageData));
  }

  savePStageData(saveStage: boolean) {
    this.pStageData = this.pStageData.reduce((resArr, currentArr) => {
      let index = resArr.findIndex((ele : any) => JSON.stringify(currentArr.year.sort()) === JSON.stringify(ele.year.sort()) && JSON.stringify(currentArr.name.sort()) === JSON.stringify(ele.name.sort()) && currentArr.type === ele.type && currentArr.settingType === ele.settingType);
      let existingPrefIndex = this.pStageData.findIndex((ele : any) => ele.id != 0 && JSON.stringify(currentArr.year.sort()) === JSON.stringify(ele.year.sort()) && JSON.stringify(currentArr.name.sort()) === JSON.stringify(ele.name.sort()) && currentArr.type === ele.type && currentArr.settingType === ele.settingType);
      if (index == -1 && existingPrefIndex < 0) resArr.push(currentArr)
      else if(index == -1 && existingPrefIndex > -1) resArr.push(this.pStageData[existingPrefIndex])
      return resArr
    }, [])
    if (!saveStage){
      this.showPStageModal = false;
      return;
    }
    if (this.pStageData.find(ele =>( ele.type !== "" && (ele.name.length === 0 || ele.year.length == 0)) || (ele.type == "" && (ele.name.length === 0 && ele.year.length == 0)))) {
      this.confirmationService.confirm({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: `There are ${this.pStageData.length - this.validPstageData} row(s) with incomplete data found. Do you want to save remaining ${this.validPstageData} row(s).`,      
        accept: () => {
          this.showPStageGrid = false;
          this.pStageData = this.pStageData.filter(ele => ele.type !== "" && (ele.name.length > 0 && ele.year.length > 0));
          this.pStageData.forEach((ele : any) => ele.selected = this.pStagesList.find((e: any) => e.id == ele.id) ? this.pStagesList.find((e: any) => e.id == ele.id).selected : true);
          this.pStagesList = JSON.parse(JSON.stringify(this.pStageData));
          this.pStagesList.forEach((ele : any) => {ele.name = ele.name.join(","); ele.year =ele.year.join(",");});
          this.selectedPStages = this.pStagesList.filter(p => p.selected);
          this.showPStageModal = false;
          setTimeout(() => {
            this.showPStageGrid = true;
          }, 10);
        }
      });
    } else {
      this.showPStageGrid = false;
      this.showPStageModal = false;
      this.pStageData.forEach((ele : any) => ele.selected = this.pStagesList.find((e: any) => e.id == ele.id) ? this.pStagesList.find((e: any) => e.id == ele.id).selected : true);     
      this.pStagesList = JSON.parse(JSON.stringify(this.pStageData))
      this.pStagesList.forEach((ele : any) => {ele.name = ele.name.join(","); ele.year =ele.year.join(",");});
      this.selectedPStages = this.pStagesList.filter(p => p.selected);
      setTimeout(() => {
        this.showPStageGrid = true;
      }, 10);
    }
  }

  addPStageRow() {
    const newId = this.commonService.getGUID();
    this.newPStageIds.push(newId);
    const object : any = {'id': newId, 'type':"", 'name':[],'year': [], crop : this.selectedCrop.Name, selected : false};
    this.pStageData = [object,...this.pStageData];
  }

  deletePStageRow() {
    let removeRows = this.pStageGridApi.getSelectedRows();
    if (this.sessionName && StaticFields.precodeScreenData?.selectedPStages) {
      const existingRows = removeRows.filter((r: any) => StaticFields.precodeScreenData.selectedPStages.findIndex((s: any) => s.id === r.id) > -1);
      removeRows = removeRows.filter((r: any) => StaticFields.precodeScreenData.selectedPStages.findIndex((s: any) => s.id === r.id) === -1);
      if (existingRows.length) {
        const msg = existingRows.length === 1 ? 'row is' : 'rows are';
        this.customMessageService.showMessage({'severity': 'warn', summary: 'Not Deleted', detail: `${existingRows.length} selected ${msg} part of ${this.sessionName} session, can't be deleted.`});    
      }
    }
    if (removeRows.length > 0)
      this.pStageData = this.pStageData.filter(ele => removeRows.indexOf(ele) == -1);
  } 

  onPStageGridReady($event: GridReadyEvent<any>) {
    this.pStageGridApi = $event.api;
  }

  onApexGridReady($event: GridReadyEvent<any>) {
    this.apexGridApi = $event.api;
  }

  shareSessions() {
    this.adUserData.splice(0);
    this.searchMemberString = "";
    this.sessionToShare = this.sessionGridApi.getSelectedRows().map((s: any) => s.name).join();
    this.showADDialog = true;
  }

  searchFromAd() {
    let params = new HttpParams();
    params = params.append("filter", this.searchMemberString);
    this.apiService.getData('SearchUsersInAD', params).subscribe((res: any) => {   
    if (res.length > 0)
      this.adUserData = res;
    else
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Not Found', detail: 'No records found for your search.'});    
    });
  }

  shareWithADUsers() {
    const userEmails = this.getUserSelectedRows.map((m: any) => m.mail);
    const selSessionIds = this.sessionGridApi.getSelectedRows().map((s: any) => s.id);
    const submitData = { users: userEmails, ids: selSessionIds, appUserId: StaticFields.appUserId, description: this.shareDescription };
    this.apiService.putData('ShareSessions', submitData).subscribe((res: any) => {
      this.getSavedSessionsForUser(this.sessionName);
      //selSessionIds.forEach((id: any) => this.sessions.find((s: any) => s.id === id).count = userEmails.length);    
      this.sessionToShare = "";
      this.showADDialog = false;
    });
  }

  onUserGridReady($event: GridReadyEvent<any>) {
    this.userGridApi = $event.api;
  }

  getAPEXSessionsForUser() {
    const selectedGes = this.gridApi.getSelectedRows();
    const selectedCrop = StaticFields.crops.find(ele => ele.Name == this.selectedCrop.Name);
    const invalidGes = selectedGes.filter((ele : any) => !selectedCrop?.MaterialType?.includes(ele?.mat_Type))
    if (invalidGes.length == selectedGes.length) {
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Invalid Material Type(s)', detail: `Crop "${this.selectedCrop.Name}" has the following material type(s): "${selectedCrop?.MaterialType}". Selected row(s) do not match the material type.`});
    } else if (invalidGes.length > 0 && invalidGes.length != selectedGes.length) {
      this.confirmationService.confirm({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: `Crop "${this.selectedCrop.Name}" has the following material type(s): "${selectedCrop?.MaterialType}". ${invalidGes.length} row(s) do not match the material type and will be ignored. Do you want to proceed?`,  
        accept : () => {
          this.openApexJobDialog();      
        }
      });
    } else if (invalidGes.length == 0){
        this.openApexJobDialog();          
    }
  }

  openApexJobDialog() {
    this.selProgram = this.selectedLevel.name === "Program(s)" && this.selectedInclusions.length > 0 ? this.programs.find((p: any) => p.code === this.selectedInclusions[0].code) : null;
    if (this.apexData && this.apexData.length > 0 && this.apexData[0].crop.toUpperCase() === this.selectedCrop.Name.toUpperCase()){
      this.showAPEXJobs = true;
    }            
    else {
      let params = new HttpParams();
      params = params.append("crop", this.selectedCrop.Name);
      params = params.append('userName', StaticFields.userInfo.onPremisesSamAccountName);
      this.apiService.getData('GetJobsByCropAndUser', params).subscribe((res: any) => {       
        if (res.length > 0) {
          this.allApexData = res;
          this.apexData = this.allApexData.filter(g => g.isLoggedUserJob);
          this.showAPEXJobs = true;
        } else
          this.customMessageService.showMessage({'severity': 'warn', summary: 'Not Found', detail: `No public Session found for crop ${this.selectedCrop.Name}.`});
      });
    }
  }

  openUsageDialog() {
    this.selUsagePrograms.splice(0);
    this.selUsageStages.splice(0);
    this.selUsageYears.splice(0);
    if (this.bulkYears.length === 1)
      this.selUsageYears.push(this.bulkYears[0]);
    if (this.bulkEditPrgs.length === 1)
      this.selUsagePrograms.push(this.bulkEditPrgs[0]);
    this.showUsageModal = true;
  }

  openNurseryDialog() {
    this.selectedExpts.splice(0);
    this.assocExpts.splice(0);
    this.selectedPrg = null;
    this.gridApi.getSelectedRows().forEach((r: any) => {
      const exptIds = r.expt_ID?.split(';');
      const exptParts = r.expt_Name?.split(';');
      const exptYrSsn = r.expt_YrSsn?.split(';');
      if (exptIds) {
        for (let i = 0; i < exptIds.length; i++) {
          if (this.assocExpts.findIndex((e: any) => e.exptId === exptIds[i]) === -1) {
            const yrSsns = exptYrSsn[i].split(':');
            this.assocExpts.push({ exptId: exptIds[i], exptName: exptParts[i], year: yrSsns[0], season: yrSsns[1] });
          }
        }
        this.assocExpts.sort((a: any , b: any) => a.exptName.localeCompare(b.exptName))
      }
    });
    this.showNurserySelection = true;
  }

  submitAPEXData() {
    if (!this.selProgram) {
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Program Not Selected', detail: `Program is required.`});
      return;
    }
    const selectedApexJob = this.apexGridApi.getSelectedRows()[0];
    const selectedGes = this.gridApi.getSelectedRows();
    const ges : any[] = [];
    const selectedCrop = StaticFields.crops.find(ele => ele.Name == this.selectedCrop.Name);
    selectedGes.forEach((ele : any) => {
      if (selectedCrop?.MaterialType?.includes(ele?.mat_Type)) {
        let obj : any = new Object();
        obj['GeId'] = ele.geid;
        obj['Name'] = ele.gE_Name;
        obj['Impute'] = 1;
        obj['Comment'] = `PCM Transfer - ${this.selProgram.code}`;
        ges.push(obj);
      }      
    });
    if (ges.length > 0) {
      const apexGeJobsToSubmit = {
        JobId : selectedApexJob.id,
        Ges: ges
      };
      this.apiService.postData('SubmitJobsToApex', apexGeJobsToSubmit, true, true).subscribe();
      this.showAPEXJobs = false;
      this.gridApi.deselectAll();
      this.gridApi.clearFocusedCell();
    } 
  }

  onLevelSearch(word: string, item: { code: string, desc: string }): boolean {
    return item.code.toLocaleLowerCase().startsWith(word.toLocaleLowerCase());
  }

  onNGSearch(word: string, item: string): boolean {
    return item.toLocaleLowerCase().startsWith(word.toLocaleLowerCase());
  }

  wrapHeaderChecked(args: any) {
    this.gridOptions.defaultColDef.wrapHeaderText = this.gridOptions.defaultColDef.autoHeaderHeight = args.checked;
    var columnDefs = this.gridApi.getColumnDefs();
    columnDefs.forEach((colDef: any) => {
      colDef.wrapHeaderText = colDef.autoHeaderHeight = args.checked;
    });
    this.gridApi.setGridOption("columnDefs", columnDefs);
  }

  showSelected(args: any) {
    const nodesToUpdate: any = [];
    if (args.checked) {
      this.rowDataCopyForFilter = this.rowData.filter((r: any) => true);
      this.rowData = this.gridApi.getSelectedRows();
      setTimeout(() => {
        this.gridApi.forEachNode((node: any) => { 
          nodesToUpdate.push(node);
        });
        this.gridApi.setNodesSelected({ nodes: nodesToUpdate, newValue: true });
      }, 10);
    } else {
      const selRows = this.gridApi.getSelectedRows();
      this.rowData = this.rowDataCopyForFilter.filter((r: any) => true);
      setTimeout(() => {
        this.gridApi.forEachNode((node: any) => { 
          if (selRows.findIndex((r: any) => r.geid === node.data.geid) > -1)
            nodesToUpdate.push(node);
        });
        this.gridApi.setNodesSelected({ nodes: nodesToUpdate, newValue: true });
      }, 10);
      this.rowDataCopyForFilter = null;
    }
  }

  onMyJobsChecked($event: CheckboxChangeEvent) {
    if (this.showMyAPEXJobs)
      this.apexData = this.allApexData.filter(g => g.isLoggedUserJob);
    else
      this.apexData = this.allApexData;
  }

  showAddRowDialog() {
    this.idList.splice(0);
    this.addGEModal = true;
  }

  get idListText(): string {
    return this.idList.join("\r\n");
  }

  set idListText(value) {
    this.idList = value.split(/\r?\n/);
    if (this.idList.length < 2)
      this.idList = value.split(",");
    this.idList = this.idList.filter((v, i, a) => a.indexOf(v) === i);
    this.idList = this.idList.map(s => s.trim()).filter(s => s);
  }

  setSearch($event: RadioButtonClickEvent) {
    if($event) {
      this.idList.splice(0);
    }
  }

  AppendNewRows() {
    const expandBy = this.getExpandOptions();
    const postData = this.setSearchData(expandBy);
    // if (this.searchBy === 'GE ID')
    //   postData['selectedGeIds'] = this.rowData.map((ele: any) => ele.geid);
    let msg: string;
    if (this.searchBy === 'CVN') { 
      const existingNames =  this.rowData.filter((r: any) => r.gE_Name).map((r: any) => r.gE_Name.toUpperCase());
      postData['selectedGeNames'] = this.idList.filter(n => !existingNames.includes(n.toUpperCase()));
      if (postData['selectedGeNames'].length === 0)
        msg = "GE Names already exist in the grid. No data to fetch";
    } else {
      const existingIds =  this.rowData.map((r: any) => r.geid);
      postData['selectedGeIds'] = this.idList.map(id => Number(id)).filter(id => id).filter(id => !existingIds.includes(id));
      if (postData['selectedGeIds'].length === 0)
        msg = "GE Ids already exist in the grid. No data to fetch";
    }
    if (msg) {
      this.customMessageService.showMessage({'severity': 'warn', summary: 'Duplicate Data', detail: msg});
      return;
    }
    // postData['selectedGeIds'] = this.searchBy !== 'CVN' ? this.idList.map(id => Number(id)).filter(id => id) : null;
    // postData['selectedGeNames'] = this.searchBy === 'CVN' ? this.idList : null;
    this.apiService.postData('AddPrecodeRows', postData, false, true).subscribe((result : any) => {
      if (result && result.groupedData) {
        // this.rowData = result.groupedData.concat(this.rowData);
        // this.gridApi!.applyTransaction({ add: selectedNodes })!
        StaticFields.precodeScreenData.data = result.groupedData.concat(StaticFields.precodeScreenData.data);
        this.rowData = result.groupedData.concat(this.rowData);
        this.rowDataCopy = JSON.parse(JSON.stringify(result.groupedData)).concat(this.rowDataCopy);
        const res = this.gridApi!.applyTransaction({
          add: result.groupedData,
          addIndex: 0,
        })!;
      }
      this.addGEModal = false;
    });
  }
}





